const translationsAr = {
    "status": "success",
    "data": {
        "lang": "ar_AR",
        "app": "hotel",
        "translation": {
            "liveBooking": {
  bookingMovedToOperationsMessage:
    'تمت معالجة حجزك بنجاح وتحويله إلى فريق العمليات لدينا للحصول على موافقة المورد.',
  pleaseWaitSupplierApproval:
    'يرجى الانتظار بينما يقوم المورد بمراجعة وتأكيد حجزك. يستغرق ذلك عادة بضع ساعات.',

  waitingSupplierApproval: 'في انتظار موافقة المورد',
  youWillBeNotified:
    'سيتم إعلامك عبر البريد الإلكتروني بمجرد رد المورد.',
                            "processingYourBooking": "جاري معالجة حجزك...",
            "stepCompletedSuccessfully": "تم إكمال الخطوة بنجاح",
            "somethingWentWrongOurTeamIsWorkingOnIt": "حدث خطأ ما. فريقنا يعمل على حل المشكلة.",
            "stepCouldNotBeCompleted": "تعذر إكمال الخطوة.",
            "stillProcessingPleaseWait": "لا يزال جارٍ المعالجة، يرجى الانتظار...",
            "waitingForSupplierApproval": "في انتظار موافقة المورد",
            "stepAlreadyCompleted": "تم إكمال الخطوة بالفعل.",
            "REVALIDATE": "إعادة التحقق",
            "RESERVATION": "الحجز",
            "SUMMARY": "الملخص",
            "PAYMENT_FINALIZATION": "إتمام الدفع",
            "bookingProcessStatus": "حالة عملية الحجز",
            "order": "الطلب",
            "lastUpdate": "آخر تحديث",
            "liveStreamingNotAvailable": "البث المباشر غير متاح — يتم استخدام التحقق الدوري كحل بديل. إذا استمرت المشكلة، فإن فريق العمليات لدينا يقوم بالمراجعة.",
            "noProgressAvailable": "لا توجد أي تحديثات على حالة الحجز حتى الآن.",
            "paymentNotRequired": "الدفع غير مطلوب لهذا الحجز (تم اختيار خيار الدفع لاحقًا)",
            "paymentProcessed": "تمت معالجة الدفع",
            "transactionId": "رقم المعاملة:",
            "processingOrderLevelJob": "جارٍ معالجة مهمة على مستوى الطلب",
            "emailSentToCustomer": "تم إرسال البريد الإلكتروني إلى العميل",
            "status": "الحالة",
            "retries": "عدد المحاولات",
            "eta": "الوقت المتوقع",
            "timestamp": "الطابع الزمني",
            "processing": "جارٍ المعالجة",
            "currentAttempt": "المحاولة الحالية",
            "of": "من",
            "failedToProcess": "فشل في المعالجة",
            "supplierApiDidNotRespond": "واجهة برمجة تطبيقات المورّد لم تستجب ضمن الإطار الزمني المسموح به.",
            "attempts": "المحاولات",
            "duration": "المدة",
            "failedAt": "فشل عند",
            "retryAvailable": "إعادة المحاولة متاحة",
            "retryStep": "إعادة محاولة الخطوة",
            "waitingForRetry": "بانتظار إعادة المحاولة بعد مشكلة مؤقتة.",
            "etaForRetry": "الوقت المتوقع لإعادة المحاولة:",
            "awaitingPreviousStep": "بانتظار إكمال الخطوة السابقة",
            "paymentWillBeProcessed": "سيتم معالجة الدفع لاحقًا",
            "emailQueued": "تمت إضافة إشعار البريد الإلكتروني إلى قائمة الانتظار",
            "willBeSentAfterPayment": "سيتم الإرسال بعد تأكيد الدفع",
            "processFailedAtStep": "فشلت العملية عند الخطوة",
            "processingStep": "جارٍ معالجة الخطوة",
            "system": "النظام",
            "bookingConfirmed": "تم تأكيد الحجز!",
            "orderApprovedSuccessfully": "تمت الموافقة على طلبك بنجاح.",
            "sentItineraryToEmail": "لقد أرسلنا برنامج الرحلة إلى بريدك الإلكتروني.",
            "orderConfirmed": "تم تأكيد الطلب",
            "allSystemsGo": "كل الأنظمة تعمل!",
            "orderNumber": "رقم الطلب",
            "confirmation": "التأكيد",
            "sentToEmail": "تم الإرسال إلى البريد الإلكتروني",
            "checkYourInbox": "تحقق من صندوق الوارد",
            "completeItinerarySent": "تم إرسال برنامج الرحلة الكامل وتفاصيل الحجز إلى عنوان بريدك الإلكتروني المسجّل.",
            "orderBeingProcessed": "جارٍ معالجة طلبك حاليًا.",
            "orderWaitingForSupplier": "طلبك حاليًا بانتظار موافقة المورّد.",
            "errorProcessingStep": "حدث خطأ أثناء معالجة هذه الخطوة.",
            "pending": "قيد الانتظار",
            "awaitingProcessing": "بانتظار المعالجة.",
            "skipped": "تم التخطي",
            "stepNotRequired": "هذه الخطوة غير مطلوبة لحجزك.",
            "completed": "مكتمل",
            "processSteps": "خطوات العملية",
            "stepsCompletedSuccessfully": "تم إكمال الخطوات بنجاح",
            "allDone": "تم الانتهاء",
            "failed": "فشل",
            "inProgress": "قيد التنفيذ",
            "loadingStatus": "جارٍ تحميل الحالة",
            "okay": "حسنًا",
            "approved": "تمت الموافقة"
            },

            "crud": {
                "updatedSuccessfully": "تم التحديث بنجاح",
                "validationFailed": "فشل التحقق",
                "fieldRequired": "حقل إلزامي",
                "operationError": "حدث خطأ",
                "emptyList": "لا توجد بيانات",
                "failToLoad": "خطأ أثناء التحميل",
                "modelNotFound": "غير موجود"
            },
            "updateCard": {
                "payment_failed_please_update_card": "فشل الدفع - يرجى تحديث البطاقة",
                "open_the_payment_form": "افتح نموذج الدفع"
            },
            "auth": {
                authTypeWarning: 'يرجى التواصل مع فريق العمليات لتفعيل العضوية - نوع المصادقة غير محدد',
                authTitle: "المصادقة باستخدام الهوية والهاتف المحمول",
                pleaseLogin: "يرجى تسجيل الدخول باستخدام بيانات الاعتماد الخاصة بك",
                verify: "تحقق",
                id: "الرقم التعريفي",
                idPlaceholder: "أدخل رقمك التعريفي",
                idPlaceholderError: "يرجى إدخال رقمك التعريفي",
                idDigits: "يجب أن يتكون الرقم التعريفي من 9 أرقام",
                phone: "الهاتف",
                phonePlaceholderError: "يرجى إدخال رقم هاتفك",
                phoneDigits: "يجب أن يتكون رقم الهاتف من 9 أرقام",
                phonePlaceholder: "أدخل رقم هاتفك",
                send: "إرسال",
                authModalTitle: "المصادقة باستخدام الرقم التعريفي والهاتف المحمول",
                loginLoaeder: "جارٍ تسجيل الدخول...",
                loginError: "فشل تسجيل الدخول. يرجى المحاولة مرة أخرى.",
                otpLoader: "جارٍ التحقق من رمز التحقق...",
                loginSuccess: "تم تسجيل الدخول بنجاح",
                otpError: "فشل التحقق من رمز التحقق. يرجى المحاولة مرة أخرى.",
                otpStartOver: "لم تستلم الرمز؟ ابدأ من جديد",
                register: "التسجيل",
                firstName: "الاسم الأول",
                lastName: "اسم العائلة",
                email: "البريد الإلكتروني",
                firstNamePlaceholder: "أدخل اسمك الأول",
                lastNamePlaceholder: "أدخل اسم عائلتك",
                emailPlaceholder: "أدخل بريدك الإلكتروني",
                firstNamePlaceholderError: "يرجى إدخال اسمك الأول",
                lastNamePlaceholderError: "يرجى إدخال اسم عائلتك",
                emailPlaceholderError: "يرجى إدخال بريدك الإلكتروني",
                emailInvalid: "يرجى إدخال عنوان بريد إلكتروني صحيح",
                nameMinLength: "يجب أن يكون الاسم حرفين على الأقل",
                registerButton: "التسجيل",
                backToLogin: "العودة إلى تسجيل الدخول",
                registrationSuccess: "تم التسجيل بنجاح",
                registrationSuccessMessage: "تم تسجيلك بنجاح",
                registrationError: "فشل التسجيل. يرجى المحاولة مرة أخرى.",
                dontHaveAccount: "ليس لديك حساب؟",
                registerHere: "التسجيل هنا",
                authWithMobile: "المصادقة باستخدام الهاتف المحمول",
                registerWithMobile: "التسجيل برقم الهاتف المحمول",
                loginTitle: "سجّل الدخول للمتابعة",
                loginDescription: "للحجز أو إدارة طلب، يرجى التحقق من رقم هاتفك. يستغرق أقل من دقيقة.",
                otpInfo: "سنرسل رمزاً لمرة واحدة (OTP). لا حاجة لكلمة مرور.",
                whyLogin: "لماذا أحتاج لتسجيل الدخول؟",
                newHere: "جديد هنا؟",
                createAccount: "إنشاء حساب",
                sendCode: "إرسال الرمز",
                privacyNotice: "لن نشارك رقمك أبداً. قد تنطبق رسوم الرسائل القصيرة.",
                mobileNumber: "رقم الهاتف المحمول",
                accountNotFound: "الحساب غير موجود",
                continueWithRegistration: "هل تريد المتابعة للتسجيل؟",
                continueRegistration: "المتابعة للتسجيل",
                cancel: "إلغاء",
                registrationStepIndicator: "الخطوة 2 من 2 — أدخل التفاصيل",
                createYourAccount: "إنشاء حسابك",
                registrationDescription: "أنشئ حساباً لإتمام الحجوزات بسرعة وتتبع طلباتك.",
                mobileHelper: "سنستخدم هذا لإرسال رمز التحقق الخاص بك.",
                emailHelper: "اختياري — لاستلام القسائم والتحديثات.",
                agreeToTerms: "أوافق على",
                terms: "الشروط",
                and: "و",
                privacyPolicy: "سياسة الخصوصية",
                alreadyHaveAccount: "لديك حساب بالفعل؟",
                logIn: "تسجيل الدخول",
                agreeToTermsError: "يرجى الموافقة على الشروط وسياسة الخصوصية",
                subscribeNewsletter: "اشترك في نشرتنا الإخبارية",
                newsletterEmailRequired: "يرجى إدخال عنوان بريدك الإلكتروني للاشتراك في النشرة الإخبارية",
                updateProfile: "تحديث الملف الشخصي",
                logout: "تسجيل الخروج",
                updateProfileSuccess: "تم تحديث الملف الشخصي",
                updateProfileSuccessMessage: "تم تحديث ملفك الشخصي بنجاح.",
                updateProfileError: "فشل تحديث الملف الشخصي. يرجى المحاولة مرة أخرى.",
                close: "إغلاق",
            },
            "upgradePlan": {
                "general": {
                    "upgrade_plan": "ترقية الخطة",
                    "upgrade_plan_to_regular": "الترقية إلى الخطة العادية",
                    "upgrade_plan_to_pro": "الترقية إلى الخطة المحترفة"
                },
                "regular": {
                    "title": "قم بالترقية الآن واحصل على الوصول إلى منتجات Agent 360!",
                    "benefits_title_text": "أنت حاليا متصل بحزمة Agent 360 Light، إذا قمت بالترقية يمكنك الحصول",
                    "text_1": "منتجات جملة Sky 360",
                    "text_2": "فنادق لجميع الوجهات حول العالم",
                    "text_3": "رحلات منتظمة ورحلات منخفضة التكلفة",
                    "text_4": "معالم جذب حول العالم",
                    "button_text": "ترقية الآن إلى Agent 360!"
                },
                "pro": {
                    "title": "قم بالترقية الآن واحصل على موقع ويب لعملك مع تصميم كامل!",
                    "benefits_title_text": "في حزمة SKY 360 Pro يمكنك الاستمتاع",
                    "text_1": "موقع ويب بنطاق فريد الخاص بك",
                    "text_2": "العلامة التجارية للأعمال - الشعار وألوان الموقع",
                    "text_3": "ترويج الحزم والرحلات على الموقع حسب الوجهات",
                    "text_4": "جميع الحجوزات التي تتم ستكون تابعة لوكالتك!",
                    "button_text": "ترقية الآن إلى Pro!"
                }
            },
            "contactUs": {
                "requestForQuotation": "طلب عرض أسعار",
                "problemWithExistingOrder": "مشكلة في الطلب الحالي",
                "customerService": "خدمة العملاء",
                "other": "أخرى",
                "messageReceivedSuccessfully": "تم استلام الرسالة بنجاح",
                "email": "البريد الإلكتروني",
                "phone": "الهاتف",
                "fullName": "الاسم الكامل",
                "writeUsMessage": "اكتب لنا رسالة",
                "send": "إرسال",
                "phoneRequired": "يرجى إدخال رقم الهاتف",
                "emailRequired": "يرجى إدخال عنوان البريد الإلكتروني",
                "fullNameRequired": "يرجى إدخال الاسم الكامل",
                "messageRequired": "يرجى إدخال رسالة",
                "nameMinLength": "يجب أن يكون الاسم حرفين على الأقل",
                "emailInvalid": "يرجى إدخال عنوان بريد إلكتروني صحيح",
                "subjectRequired": "يرجى اختيار الموضوع",
                "selectSubject": "اختر الموضوع",
                "messageMin": "يجب أن تحتوي الرسالة على 10 أحرف على الأقل",
                "aboutUs": "معلومات عنا"
            },
            "cart": {
                "addToCart": "أضف إلى السلة",
                "select": "اختر",
                "remove": "إزالة",
            },
            "customerSupport": {
                "customerService": "خدمة العملاء",
                "sendMessageAndGetNotified": "أرسل لنا رسالة وسيرد عليك المزاد قريباً",
                "callUs": "اتصل بنا: "
            },
            "roomInfo": {
                "info": "وصف الغرفة",
                "viewAllThePhotos": "عرض جميع الصور",
                "roomSize": "مساحة الغرفة (متر مربع)",
                "peopleInTheRoom": "الأشخاص في الغرفة",
                "doubleBed": "سرير مزدوج"
            },
            "conceptsList": {
                "conceptsListTitle": "عنوان قائمة المفاهيم",
                "includesActivities": "يتضمن جذب الهدايا",
                "includesActivity": "يتضمن جذب هدية",
                "includeInPackage": "يتضمن في الحزمة",
                "transfer": "النقل",
                "includesTransfer": "يتضمن النقل",
                "transferContent": "نقل HOS بسعر الحزمة",
                "baseBoard": "لوحة الأساس",
                "autoApprove": "الموافقة التلقائية",
                "airways": "الخطوط الجوية",
                "flightFrom": "رحلة من",
                "flightBack": "رحلة العودة",
                "nights": "ليال",
                "numberOf": "عدد",
                "toOrder": "للطلب",
                "noPackagesFound": "لم يتم العثور على حزم",
                "moreDeals": "المزيد من العروض",
                "pricePerPerson": "السعر لكل شخص"
            },
            "wallet":{
                future: "أرباح غير محققة",
                creditCard:"بطاقة إئتمان",
                cancel: "إلغاء",
                forConfirmationRedemption: "هل أنت متأكد أنك تريد استبدال الألماس؟",
                TotalDiamondsYouWillReceive: "إجمالي الألماس الذي ستحصل عليه",
                max: "الحد الأقصى",
                currentOrderTotal: "إجمالي الطلب الحالي",
                MaximumRedeemable: "الحد الأقصى القابل للاستبدال:",
                UseMax: "استخدم الحد الأقصى",
                Apply: "تطبيق",
                Applying: "جارٍ التطبيق...",
                RedeemDiamonds: "استبدال الألماس",
                RemainingDiamonds: "الألماس المتبقي",
                DiscountedValue: "القيمة بعد الخصم",
                RedeemedAmount: "المبلغ المستبدل",
                Redeemed: "تم الاستبدال",
                totalValue: "القيمة الإجمالية",
                diamondsRate: "1 ألماس = 1 شيكل",
                availableDiamonds: "الألماس المتاح",
                diamondBalance: "رصيد الألماس",
                discount: "خصم",
                Subtotal: "المجموع الفرعي",
                paymentDetails: "تفاصيل الدفع",
                totalPayment: "إجمالي الدفع:",

                "wallet": "المحفظة",
                "walletTransactions": "معاملات المحفظة",
                "walletBalance": "رصيد المحفظة",
                "diamonds": "الماس",
                "diamondsAreAvailableAtYourDisposal": "الماس متاح تحت تصرفك",
                "paymentWithDiamonds": "الدفع بالماس",
                "returnToOrderManagement": "العودة إلى إدارة الطلبات",
                "reserve": "احتياطي",
                "finalize": "إنهاء",
                "release": "إطلاق",
                "partialRealization": "تحقيق جزئي",
                "fullRealization": "تحقيق كامل",
                "selectNumberOfDiamondsForPartialUse": "اختر عدد الماس للاستخدام الجزئي",
                "useAllTheDiamondsIHave": "استخدام كل الماس الذي أملكه",
                "save": "حفظ",
                "confirm": "تأكيد",
                "forConfirmation": "للتأكيد",
                "totalAgentFee": "إجمالي رسوم الوكيل",

                "dynamicLabels": {
                    'availableDiamondsForPayment': `لديك #{amount} ماسة متاحة للدفع، بقيمة #{price}`,
                    'XOfDiamondsWorthY': `#{amount} ماسة، بقيمة #{price}`,
                    'totalDiamondsYouHaveAccumulatedOverTheLast12MonthsAsOfToday': `إجمالي الماس الذي جمعته خلال الـ 12 شهرًا الماضية حتى اليوم`,
                  },
            },
            "viewFlight": {
                "pleaseSelectDestinationAirport": "يرجى اختيار مطار الوصول",
                "noNearbyAirportFound": "لم يتم العثور على مطار قريب. يرجى البحث عن مطار والتأكد من أنه يقع قريب من الفندق",
                "chooseAirportYouWantToArrive": "اختر المطار الذي تريد الوصول إليه",
                "chooseAirportYouWantToArriveDescription": "يرجى الاختيار المطار القريب من الفندق",
                "updateAirport": "تحديث المطار",
                "flightFrom": "رحلة من",
                "flightChange": "تغيير الرحلة",
                "totalChange": "التغيير الكلي",
                "noFlightsAvailableForSelectedDates": "لا توجد رحلات متاحة في التواريخ المحددة، يرجى اختيار تواريخ أخرى",
                "show_tickets_with_different_fare_combinations": "عرض التذاكر بتركيبات أسعار مختلفة",
                "ticketFare": "السعر",
                "ticketInfo": "معلومات التذكرة",
                "termsAndConditions": "الشروط والأحكام",
                "ifTicketIncludeSeat": "إذا كانت التذكرة تشمل مقعدًا - يجب على العميل اختياره من موقع الخطوط الجوية",
                "inCaseOfChange": "في حالة التغيير - يجب على العميل دفع مبلغ إضافي إذا كانت التذكرة المحدثة أعلى، وهناك أيضًا رسوم خدمة إضافية وفقًا لشروط وخدمات الموقع",
                "inCaseOfCancellation": "في حالة الإلغاء - ستكون هناك رسوم خدمة إضافية وفقًا لشروط وخدمات الموقع",
                "error4305Title": "عذرًا، الرحلة محجوزة بالكامل",
                "error4305Content": "نعتذر، ولكن يبدو أن المقاعد لهذا العرض قد نفدت، ولا يمكننا المتابعة مع الشراء. سيتم توجيهك إلى الصفحة الرئيسية.",
                "TC": "الشروط والأحكام",
                "flights": "الرحلات",
                "title": "الرحلة المختارة، تحقق من التفاصيل وتابع إلى الدفع",
                "addBaggage": "إضافة أمتعة",
                "closeAddBaggage": "إخفاء الخيارات",
                "addTrolly": "إضافة عربة",
                "somethingWetWrong": "حدث خطأ ما",
                "suitcasePrice": "سعر الحقيبة",
                "trollyPrice": "سعر العربة",
                "totalPerPassenger": "المجموع لكل راكب",
                "updatePassengers": "تحديث عدد الركاب",
                "search": "بحث",
                "seating": "المقاعد",
                "cancelation": "إلغاء التذكرة",
                "meal": "وجبات",
                "trolly": "عربة",
                "suitcase": "حقيبة",
                "changeFlight": "تغيير التذكرة",
                "extension": "تمديد",
                "totalToBePaid": "المجموع الواجب دفعه",
                "choose": "اختيار",
                "checkAmenities": "تحقق من وسائل الراحة",
                "description": "الوصف",
                "amenityType": "نوع وسائل الراحة",
                "flightFromAmenities": "وسائل راحة لرحلة الذهاب",
                "flightBackAmenities": "وسائل راحة لرحلة العودة",
                "BAGGAGE": "الأمتعة",
                "2 CHECKED BAGS UP TO 32KG EACH": "حقيبتان مسجلتان تصل كل منهما إلى 32 كجم",
                "2 CABIN BAGS UP TO 8KG": "حقيبتان في الكابينة تصل كل منهما إلى 8 كجم",
                "BRANDED_FARES": "أسعار العلامات التجارية",
                "STANDARD SEAT RESERVATION": "حجز مقعد قياسي",
                "MILEAGE_ACCRUAL": "تراكم الأميال",
                "MEAL": "وجبة",
                "SNACK": "وجبة خفيفة",
                "COMPLIMENTARY FOOD AND BEV": "طعام ومشروبات مجانية",
                "ENTERTAINMENT": "ترفيه",
                "MAGAZINES / NEWSPAPER": "مجلات / صحف",
                "LOUNGE": "صالة",
                "LOUNGE ACCESS": "دخول الصالة",
                "TRAVEL_SERVICES": "خدمات السفر",
                "PRIORITY BAGGAGE": "أمتعة الأولوية",
                "PRIORITY CHECK IN": "تسجيل دخول الأولوية",
                "PRIORITY SECURITY": "أمان الأولوية",
                "PRIORITY BOARDING": "صعود الأولوية",
                "IN FLIGHT ENTERTAINMENT": "ترفيه أثناء الرحلة",
                "PRE_RESERVED_SEAT": "مقعد محجوز مسبقًا",
                "PRIVACY SEAT BUSINESS CLASS": "مقعد خصوصية درجة رجال الأعمال",
                "CHANGE BEFORE DEPARTURE": "تغيير قبل المغادرة",
                "CHANGE AFTER DEPARTURE": "تغيير بعد المغادرة",
                "REFUND BEFORE DEPARTURE": "استرداد قبل المغادرة",
                "REFUND AFTER DEPARTURE": "استرداد بعد المغادرة",
                "allFares": "جميع الأسعار",
                "fareChangedSuccessfully": "تم تغيير السعر بنجاح",
                "openFares": "فتح الأسعار",
                "selectedFare": "السعر المختار",
                "fullInfo": "معلومات كاملة",
                "MILEAGE ACCRUAL": "تراكم الأميال"
            },
            "room": {
                "roomSize": "حجم الغرفة",
                "bedType": "نوع السرير",
                "breakfastIncluded": "الإفطار مشمول",
                "noAvailabilityOnSelectedDates": "لا توجد غرف متوفرة في التواريخ المختارة"
            },
            "promotion": {
                "modelNotFound": "الصفحة غير موجودة",
                "failToLoad": "فشل في تحميل الصفحة!"
            },
            "searchDatePicker": {
                "showingAllResultsWithin": "عرض جميع النتائج في",
                'PARTICIPANTS': 'المشاركون',
                'CITY': 'المدينة',
                'COUNTRY': 'البلد',
                'EVENT_TYPE': 'نوع الحدث',
                'TOURNAMENTS': 'البطولات',
                'VENUES': 'الأماكن',
                "events":"الأحداث",
                "sportsAndEvents":"الرياضة والأحداث",
                checking: "يتم التحقق",
                providers: "المزودون",
                keepScanning: "يتم التحقق",
                validatePricesInRealTime: "يتم التحقق",
                foundSoFar: "يتم التحقق",
                return: "العودة",
                calendar: "التقويم",
                cubes: "المكعبات",
                requiredFields: "يرجى ملء جميع الحقول المطلوبة: الوجهة، المغادرة، والتواريخ لعرض النتائج.",
                otherDeparture: "رحيل آخر",
                departure: "رحيل",
                "freeCancellationTooltipText": "الإلغاء المجاني ينطبق فقط على الغرف الفندقية",
                "mapView": "عرض الخريطة",
                "dynamicPackages": "باقات ديناميكية",
                "includeEvents": "تضمين الأحداث",
                "includeFullPackage": "تضمين الباقة الكاملة",
                "package_hotel_flight": "باقة (فندق + رحلة)",
                "package_hotel_flight_events": "باقة (فندق + رحلة + أحداث)",
                "hotel_plus_flight": "فندق + رحلة",
                "hotel_plus_flight_events": "فندق + رحلة + أحداث",
                "searchHotelsByNameTitle": "البحث عن فندق بالاسم للوجهة المحددة",
                "choose_packages_according_to": "اختر الحزم حسب",
                "tech_stops": "توقفات فنية",
                "freePlanFlightSearchFooterText": "الخطة المجانية تسمح بالبحث عن رحلات الطيران العارض فقط! إذا كنت تريد رحلات GDS",
                "clickHere": "اضغط هنا",
                "approveSelection": "اعتماد الاختيار",
                "attractions": "معالم",
                "attractions_type": "أنواع المعالم",
                "room": "غرفة",
                "addRoom": "إضافة غرفة",
                "removeRoom": "إزالة غرفة",
                "needAnotherRoomAddToCart": "تحتاج غرفة أخرى؟ فقط أضفها إلى السلة.",
                "indirectFlight": "رحلة غير مباشرة",
                "directFlightLabel": "رحلة مباشرة",
                "city": "مدينة",
                "hotel": "فندق",
                "searchForDestination": "ابحث عن وجهات",
                "searchByDestinationAndHotel": "البحث حسب الوجهات والفنادق",
                "searchHotelOrDestination": "ابحث عن فندق أو وجهة",
                "date": "التاريخ",
                "noResultsForThisDate": "لا توجد حزم لهذا التاريخ",
                "searchDestination": "بحث عن وجهة",
                "pleaseSelectDestination": "يرجى اختيار وجهة",
                "airlineInformation": "معلومات الخطوط الجوية",
                "airlineCode": "الرمز",
                "title": "احجز إجازة أحلامك",
                "hotelOnly": "ابحث عن إجازة حسب التواريخ",
                "hotelWithFlight": "ابحث عن إجازة تشمل الرحلة",
                "oneWay": "ذهاب فقط",
                "roundTrip": "ذهاب وعودة",
                "selectDate": "اختيار التواريخ",
                "startDate": "تاريخ البدء",
                "endDate": "تاريخ الانتهاء",
                "flights": "بحث عن رحلات",
                "packages": "حزم العطلات",
                "hotels": "فنادق خارج البلاد",
                "israelPackage": "إجازة في إسرائيل",
                "specialPackage": "حزم خاصة",
                "passengers": "الركاب",
                "adults": "البالغون",
                "adult": "بالغ",
                "child": "طفل",
                "children": "أطفال",
                "infant": "رضيع",
                "infants": "رضع",
                "infantsWarningMessage": "يجب أن يكون الرضيع أقل من سنتين في رحلة الذهاب والعودة",
                "select": "اختر",
                "noResults": "لا نتائج",
                "checkout": "احجز الآن",
                "regularPrice": "السعر العادي",
                "from": "من",
                "purchase": "شراء",
                "selectNewFlight": "اختر رحلة جديدة",
                "search": "بحث",
                "rooms": "غرف",
                "composition": "تكوين",
                "chooseComposition": "اختر التكوين",
                "numberOfGuests": "عدد الضيوف",
                "checkOut": "تسجيل المغادرة",
                "checkIn": "تسجيل الوصول",
                "whatVacation": "أي نوع من الإجازات",
                "youWant": "تريد",
                "vacationFriendsWith": "إجازة مع الأصدقاء",
                "familyVacation": "إجازة عائلية",
                "romanticVacation": "إجازة رومانسية",
                "notAvailable": "غير متاح",
                "roomAvailableDuringTheWeek": "توافر الغرفة خلال الأسبوع",
                "followingDates": "التواريخ التالية",
                "vacation": "إجازة",
                "abroad": "في الخارج",
                "inIsrael": "في البلاد",
                "destination": "جميع الوجهات",
                "chooseDestination": "اختر الوجهات",
                "findDreamVacation": "ابحث عن إجازتك المثالية بنقرة واحدة",
                "searchResTitle": "اختر الحزمة المناسبة لك",
                "directFlight": "رحلة مباشرة",
                "stops": "توقفات",
                "checkHotel": "تحقق من الفندق",
                "noRating": "بدون تقييم",
                "toOrder": "للطلب",
                "selectAgain": "اختر مرة أخرى",
                "selectFlight": "اختر رحلة",
                "reselectFlight": "اختر الرحلة مرة أخرى",
                "flightCanBeReSelectedNextPage": "يمكن اختيار الرحلة مرة أخرى في الصفحة التالية",
                "flightSelectedSuccessfully": "تم اختيار الرحلة بنجاح",
                "dynamicFlight": "رحلة ديناميكية",
                "bundle": "رحلة مجمعة",
                "freeCancelation": "إلغاء مجاني",
                "partially_operated_by_airlines": "تشغيل جزئي بواسطة شركات الطيران",
                "connect_in_airport": "التوصيل في المطار",
                "arrives": "يصل",
                "journey_duration": "مدة الرحلة",
                "short_wait": "انتظار قصير",
                "long_wait": "انتظار طويل",
                "flight_number": "رقم الرحلة",
                "stop_1": "توقف واحد",
                "activeFlight": "رحلة نشطة",
                "flightSearch": "بحث عن رحلة",
                "nights": "ليال",
                "until": "حتى التاريخ",
                "untilYouSearchForFlightDate": "حتى تاريخ بحث الرحلة",
                "destinationFrom": "المغادرة",
                "packageSearch": "بحث عن حزمة",
                "destinationTo": "الوصول",
                "selectDestination": "اختيار الوجهة",
                "trollyIsIncluded": "العربة مشمولة",
                "trollyIsNotIncluded": "العربة غير مشمولة",
                "suitcaseIsIncluded": "الحقيبة مشمولة",
                "suitcaseIsNotIncluded": "الحقيبة غير مشمولة",
                "operated_by_airlines": "تشغيل بواسطة"
            },
            "specialDeal": {
                "closeTheDeal": "إغلاق الصفقة ›",
                "endsIn": "ينتهي في",
                "specialDealForTheWeekend": "صفقة خاصة لعطلة نهاية الأسبوع",
                "from": "من تاريخ",
                "until": "حتى تاريخ"
            },
            "footer": {
                "backToTop": "العودة إلى الأعلى",
                "allRightsReserved": "© جميع الحقوق محفوظة. يمنع نسخ المحتوى من الموقع بدون إذن.",
                "developBy": "تطوير بواسطة SKY 360 Tech.",
                "thePurchaseOnTheWebsiteIsSecure": "الشراء على الموقع آمن.",
                "talkToUs": "كيف تتحدث إلينا؟",
                "address": "العنوان",
                "phoneAndWhatsapp": "الهاتف أو WhatsApp",
                "phone": "الهاتف",
                "whatsapp": "WhatsApp"
            },
            "newsletter": {
                "title": "اشترك في نشرتنا الإخبارية",
                "subtitle": "احصل على عروض حصرية وإلهام للسفر",
                "placeholder": "أدخل بريدك الإلكتروني",
                "subscribe": "اشترك",
                "pleaseEnterEmail": "يرجى إدخال عنوان بريدك الإلكتروني",
                "somethingWentWrong": "حدث خطأ ما. يرجى المحاولة مرة أخرى."
            },
            "attractions": {
                "showingMoreResults": "عرض المزيد من النتائج",
                "noMoreResults": "لا يوجد المزيد من النتائج",
                "NoResultsMatchedTheFilterValues": "لا توجد نتائج تطابق قيم الفلتر",
                "inclusions": "المشمولات",
                "exclusions": "الاستثناءات",
                "overviewOfTheTrip": "نظرة عامة على الرحلة",
                "immediateConfirmation": "تأكيد فوري",
                "pricePerPerson": "السعر لكل شخص",
                "totalForXXXPeople": "الإجمالي لـ XXX أشخاص",
                "toOrder": "للطلب",
                "freeCancelation": "إلغاء مجاني",
                "showAll": "عرض التفاصيل",
                "hideAll": "إخفاء التفاصيل",
                "days": "أيام",
                "rating": "التقييم",
                "supplier": "المورد",
                "location": "الموقع",
                "pricePerPersonFrom": "السعر لكل شخص من",
                "selectDatesAndTravelers": "اختر التواريخ والمسافرين",
                "bookNowWithFreeCancellation": "احجز الآن مع إمكانية الإلغاء المجاني",
                "updateSearch": "تحديث البحث",
                "activities-health-wellness-spas": "المنتجعات",
                "activities-action-entertainment-shows-events": "عروض وفعاليات",
                "activities-nature-outdoors-zoos-aquariums": "حدائق الحيوان والأحياء المائية",
                "activities-food-drink": "الطعام والشراب",
                "activities-action-entertainment-shopping": "التسوق",
                "activities-nature-outdoors-tickets-passes": "تذاكر وبطاقات الدخول",
                "activities-action-entertainment-rentals-rides": "التأجير والرحلات",
                "activities-transportation": "النقل",
                "activities-culture-shows-events": "عروض ثقافية وفعاليات",
                "activities-nature-outdoors": "الطبيعة والهواء الطلق",
                "activities-tours-by-theme-shopping-tours": "جولات تسوق",
                "activities-workshops-classes-sport-lessons": "دروس رياضية",
                "activities-action-entertainment-tickets-passes": "تذاكر وبطاقات",
                "activities-workshops-classes-music-dance": "موسيقى ورقص",
                "activities-food-drink-workshops-classes": "ورش عمل وفصول",
                "activities-health-wellness-relaxation": "استرخاء",
                "activities-tours-by-theme-food-drink-tours": "جولات الطعام والشراب",
                "activities-workshops-classes": "ورش عمل وفصول",
                "activities-health-wellness-beauty-treatments": "علاجات التجميل",
                "activities-action-entertainment-water": "ماء",
                "activities-workshops-classes-arts-crafts": "فنون وحرف",
                "activities-tours-by-theme": "جولات حسب النوع",
                "activities-action-entertainment-land": "بر",
                "activities-tours-by-theme-sport-tours": "جولات رياضية",
                "activities-culture": "ثقافة",
                "activities-tours-by-theme-walking-tours": "جولات سيرًا على الأقدام",
                "activities-health-wellness-alternative-medicine": "الطب البديل",
                "activities-tours-by-theme-art-culture-tours": "جولات الفن والثقافة",
                "activities-workshops-classes-cultural-immersion": "الغمر الثقافي",
                "activities-health-wellness": "الصحة والعافية",
                "activities-nature-outdoors-air-activities": "أنشطة جوية",
                "activities-tours-by-theme-luxury-tours": "جولات فاخرة",
                "activities-tours-by-theme-historical-heritage-tours": "جولات التراث التاريخي",
                "activities-culture-art-culture-tours": "جولات الفن والثقافة",
                "activities-action-entertainment-air": "أنشطة جوية",
                "activities-tours-by-theme-nature-wildlife-tours": "جولات الطبيعة والحياة البرية",
                "activities-tours-by-theme-discovery-tours": "جولات الاكتشاف",
                "activities-nature-outdoors-wildlife-nature-observation": "مراقبة الطبيعة والحياة البرية",
                "activities-action-entertainment": "أكشن وترفيه",
                "activities-tours-by-theme-museum-exhibition-tours": "جولات المتاحف والمعارض",
                "activities-workshops-classes-food-drink": "ورش الطعام والشراب",
                "activities-tours-by-theme-virtual-tours": "جولات افتراضية",
                "activities-tours-by-theme-special-tours": "جولات خاصة",
                "activities-nature-outdoors-land-activities": "أنشطة برية",
                "activities-transportation-rentals-rides": "التأجير والرحلات",
                "activities-nature-outdoors-water-activities": "أنشطة مائية",
                "activities-food-drink-restaurants-bars": "مطاعم وبارات",
                "activities-food-drink-food-drink-tours": "جولات الطعام والشراب",
                "activities-no-category": "بدون تصنيف",
                "activities-health-wellness-retreats": "المعتكفات",
                "activities-action-entertainment-sport-lessons": "دروس رياضية",
                "activities-tours-by-theme-self-guided-tours": "جولات ذاتية التوجيه",
                "activities-action-entertainment-multi-adventure-games": "ألعاب المغامرات المتعددة",
                "activities-food-drink-tickets-passes": "تذاكر وبطاقات",
                "activities-tours-by-theme-night-tours": "جولات ليلية",
                "activities-culture-tickets-passes": "تذاكر وبطاقات",
                "activities-transportation-transfers": "التحويلات",
                "hours": "ساعات"
            },
            "sportsAndEvents": {
                "atLeastOneTicketMustBeSelected": "يجب أن يتم اختيار تذكرة واحدة على الأقل",
                "dateNotFinal": "التاريخ غير محدد",
                "timeNotFinal": "الوقت غير محدد",
                "dateAndTimeNotFinal": "التاريخ والوقت غير محدد",
                "dateIsSubjectToChange": "التاريخ معلومات متغيرة",
                "timeIsSubjectToChange": "الوقت معلومات متغيرة",
                "dateAndTimeAreSubjectToChange": "التاريخ والوقت معلومات متغيرة",
                "onlyAFewTicketsLeft": "فقط بضع تذاكر متاحة",
                "pricePerTicket": "سعر التذكرة للشخص",
                "totalPrice": "السعر الإجمالي",
                "cannotChangeSeatingFromThisPage": "لا يمكنك تغيير الجلوس من هذه الصفحة",
                "reselectSeating": "إعادة اختيار الجلوس",
                "sportsAndEvents": "الرياضة والأحداث",
                "noTitle": "حدث",
                "comingSoon": "قريبًا!",
                "noTicketsAvailable": "لا توجد تذاكر متوفرة",
                "selectTickets": "اختر التذاكر",
                "notifyMe": "أخبرني",
                "notifyMeDescription": "أدخل بريدك الإلكتروني ليتم إشعارك عندما تصبح التذاكر متاحة",
                "notifyMeEmailPlaceholder": "أدخل عنوان بريدك الإلكتروني",
                "notifyMeSubmit": "أخبرني",
                "notifyMeSuccess": "سيتم إشعارك عندما تصبح التذاكر متاحة",
                "notifyMeError": "فشل إرسال الإشعار. يرجى المحاولة مرة أخرى.",
                "notifyMeEmailRequired": "يرجى إدخال عنوان بريدك الإلكتروني",
                "notifyMeEmailInvalid": "يرجى إدخال عنوان بريد إلكتروني صحيح",
                "tournament": "البطولة",
                "participants": "المشاركون",
                "eventType": "نوع الحدث",
                "vipPackage": "باقة VIP",
                "hold24Hours": "حجز لمدة 24 ساعة",
                "instantConfirmation": "تأكيد فوري",
                "offlineStock": "مخزون غير متصل",
                "rating": "التقييم",
                "location": "الموقع",
                "dateTimeSeparator": " في ",
                "viewOnMap": "عرض على الخريطة",
                "selectQuantity": "اختر الكمية",
                "avenue": "الشارع",
                "venue": "المكان",
                "city": "المدينة",
                "country": "الدولة",
                "state": "الولاية",
                "zip": "الرمز البريدي",
                "latitude": "خط العرض",
                "longitude": "خط الطول",
                "whereWillISit": "أين سأجلس؟",
                "seatingArrangements": "ترتيبات الجلوس",
                "seatingInPairs": "الجلوس في أزواج",
                "seatingInPairsDescription": "نحن ملتزمون بإجلاسكم في أزواج (اثنين معًا) ما لم تشير فئة التذكرة خلاف ذلك.",
                "seatingInPairsNote": "يرجى ملاحظة: في بعض الملاعب (وعلى وجه الخصوص ملعب كامب نو في برشلونة وملعب سانتياغو برنابيو في ريال مدريد) تشمل \"الجلوس في أزواج\" المقاعد المتصلة قطريًا أو عموديًا.",
                "seatingThreeTogether": "الجلوس ثلاثة معًا أو أكثر",
                "seatingThreeTogetherDescription": "عندما تحتاج إلى ثلاث تذاكر أو أكثر، سنبذل قصارى جهدنا لإجلاسكم معًا؛ ومع ذلك، لا يمكننا ضمان ذلك.",
                "seatingThreeTogetherNote": "إذا كان يجب عليك الجلوس معًا، يرجى التحقق من التوفر مع فريق خدمة العملاء لدينا، عبر الهاتف أو البريد الإلكتروني. في معظم الحالات، سنتمكن من تأكيد طلب محدد أو تقديم حل بديل.",
                "homeFansOrAwayFans": "مشجعو الفريق المضيف أو الضيف",
                "homeFansDescription": "جميع التذاكر لقسم الفريق المضيف، ما لم يُذكر خلاف ذلك (\"قسم الضيوف\").",
                "homeFansBehaviorCode": "وفقًا لقواعد السلوك الخاصة بالمنظم، لا يُسمح لك بالهتاف لصالح الفريق الضيف أو ارتداء ألوان الفريق الضيف. يُنصح المشاركون أيضًا بارتداء ملابس ذات ألوان محايدة إذا لم يكونوا يدعمون الفريق المضيف. قد يُفسر عدم اتباع هذه القواعد على أنه استفزاز وقد يؤدي إلى طردك من الملعب.",
                "neutralVenueNote": "المواصفات أعلاه لا تنطبق على المباريات التي تُلعب في ملعب محايد (مثل نهائي دوري أبطال أوروبا، نهائي الدوري الأوروبي، نهائي كأس الاتحاد الإنجليزي، نهائي كأس الدوري أو أحداث كأس العالم). ما لم يُذكر خلاف ذلك، يمكن أن تقع المقاعد في أي من الأقسام، لذلك يُنصح بارتداء ملابس ذات ألوان محايدة.",
                "singleTickets": "تذاكر فردية",
                "singleTicketsDescription": "نقدم أحيانًا تذاكر مصنفة على وجه التحديد على أنها \"فردية\".",
                "singleTicketsNote": "هذه التذاكر عادة ما تكون أرخص، لكنها كما هي - فردية. إذا اشتريت تذكرتين \"فرديتين\" فلن تجلسا معًا.",
                "groupSeating": "الجلوس الجماعي",
                "groupSeatingDescription": "للحصول على 8 تذاكر أو أكثر، يرجى التحقق من التوفر للجلوس الجماعي والسعر مع فريق خدمة العملاء لدينا، عبر الهاتف أو البريد الإلكتروني. قد يكون الجلوس الجماعي أقل تكلفة أو أكثر، حسب التوفر.",
                "groupSeatingNote": "إذا كانت فئة التذكرة التي اخترتها تسمح بذلك - يمكنك المضي قدمًا وتقديم الطلب دون الاتصال بنا أولاً، ولكن يرجى التذكر، في هذه الحالة يمكننا فقط ضمان إجلاسكم في أزواج.",
                "pleaseNote": "يرجى ملاحظة",
                "pleaseNoteDescription": "المعلومات أعلاه حول ترتيبات الجلوس عامة وقد لا تتطابق مع الوصف الدقيق للتذكرة التي اخترتها. عندما يكون متاحًا، نقدم مخطط الجلوس ذا الصلة أو خريطة المكان.",
                "pleaseNoteConsult": "يرجى استشارته عند مراجعة فئات التذاكر لهذا الحدث.",
                "haveMoreQuestions": "هل لديك المزيد من الأسئلة؟",
                "contactUsForInfo": "لمزيد من المعلومات، لا تتردد في الاتصال بنا",
                "eventLoadError": "فشل تحميل تفاصيل الحدث",
                "quantity": "الكمية",
                "deliveryMethod": "طريقة التسليم",
                "selectDeliveryMethod": "اختر طريقة التسليم",
                "ticketsAvailable": "تذاكر متاحة",
                "available": "متاح",
                "quantityCannotBeZero": "لا يمكن أن تكون الكمية 0",
                "deliveryMethodNotFound": "طريقة التسليم غير موجودة",
            },
            "packages": {
                "availableSeats": "مقاعد متوفرة",
                "from": "من تاريخ",
                "until": "حتى تاريخ",
                "breakfastIncluded": "يشمل الإفطار",
                "includesMassageAndSpa": "يشمل مساج وسبا!",
                "lastRoom": "الغرفة الأخيرة!",
                "includesTransfers": "يشمل التحويلات",
                "includesActivities": "يشمل الأنشطة",
                "nights": "ليال",
                "withoutBaggage": "بدون أمتعة",
                "directFlight": "رحلة مباشرة",
                "oneStop": "توقف واحد",
                "numOfStops": "عدد التوقفات",
                "flightDetails": "تفاصيل الرحلة",
                "flightFrom": "من -> إلى",
                "flightBack": "من -> إلى",
                "hours": "ساعات",
                "flightNumber": "رقم الرحلة",
                "airLine": "الخطوط الجوية",
                "suitcaseWeight": "وزن الحقيبة المشمول كجم",
                "trollyWeight": "وزن العربة المشمول كجم",
                "includedActivitiesTitle": "الجذب والجولات المشمولة في الحزمة",
                "checkAllPictures": "عرض جميع الصور",
                "affiliateWith": "بالتعاون مع",
                "addButtonDisabledTooltip": "الطلب محدود بكمية الغرف - لا يمكن إضافة غرفة أخرى. لتغيير غرفة، قم بإزالة غرفة من السلة",
                "holidaySchedule": "جدول العطلة",
                "passengers": "الركاب",
                "isRoundTrip": "سعر الأمتعة للرحلة الذهاب والعودة *",
                "includesFlights": "يشمل الرحلات",
                "includesEventTicket": "يشمل تذكرة الحدث",
                "returnFlight": "رحلة العودة",
                "outboundFlight": "رحلة الذهاب",
                "trollyWeight2": "وزن العربة/الحقيبة كجم",
                "suitcaseWeight2": "وزن الحقيبة كجم",
                "included": "مشمول",
                "notIncluded": "غير مشمول",
                "perPax": "لكل راكب",
                "addSuitcaseLater": "يمكنك إضافته لاحقًا",
                "clickForDetails": "انقر هنا لتفاصيل الجذب",
                "includedInPackage": "مشمول في الحزمة!"
            },
            "roomPricing": {
                "noRoomsAvailableForSelectedDates": "لا توجد غرف متاحة في التواريخ المحددة، يرجى اختيار تواريخ أخرى",
                "noRoomsAvailable": "لا توجد غرف متاحة للتواريخ والضيوف المحددين.",
                "for": "لـ",
                "addPassenger": "إضافة راكب",
                "pricePerPerson": "السعر لكل شخص",
                "pricePerRoom": "السعر لكل غرفة",
                "priceForAllRooms": "السعر لجميع الغرف",
                "payOnSpot": "الدفع عند الوصول",
                "resort_fee": "رسوم المنتجع",
                "occupancy_tax": "ضريبة الإشغال",
                "totalPrice": "السعر الإجمالي",
                "pricePerInfant": "السعر لكل رضيع",
                "composition": "التكوين",
                "adultsInTheRoom": "البالغين",
                "children": "الأطفال",
                "adults": "البالغين",
                "single": "بالغ واحد",
                "child": "طفل",
                "selectInfantCount": "اختر من القائمة",
                "infant": "رضيع",
                "1infant": "رضيع واحد",
                "2infants": "رضيعان",
                "infants": "رضع",
                "noInfants": "بدون رضع",
                "all_include": "كل شيء مشمول",
                "breakfast": "إفطار",
                "activities": "اختر جولة",
                "half_board": "نصف إقامة",
                "half_board_kosher": "نصف إقامة كوشر",
                "full_board": "إقامة كاملة",
                "sleep_only": "غرفة فقط",
                "breakfast_kidush": "وجبة الصباح والمساء يوم الجمعة",
                "addToCard": "أضف إلى الطلب",
                "inPackageDates": "في تواريخ الحزمة",
                "chooseRoom": "اختر تكوين الغرفة",
                "nights": "ليالي",
                "boardType": "نوع الإقامة",
                "filters": "فلاتر",
                "freeCancellation": "إلغاء مجاني",
                "roomInfo": "معلومات الغرفة",
                "noAvailableRooms": "لا توجد غرف متاحة للتواريخ المحددة",
                "noAvailableRoomsForDates": "الغرفة غير متوفرة للتواريخ المحددة",
                "addInfant": "إضافة رضيع",
                "roomFacilities": "مرافق الغرفة",
                "show_images": "عرض الصور",
                "autoApprove": "الموافقة التلقائية",
                "includedInPrice": "مشمول في السعر",
                "until": "حتى",
                "no": "لا",
                "vat": "ضريبة القيمة المضافة",
                "is": "هو",
                "not": "ليس",
                "city_tax": "ضريبة المدينة",
                "cancellation_policy": "سياسة الإلغاء",
                "your_local_time": "*الوقت المحلي لك",
                "additional_price_info": "معلومات سعر إضافية",
                "policy": {
                    "freeCancallationUntil": "إلغاء مجاني بهذا السعر حتى",
                    "freeCancallationUntil2": "إلغاء مجاني حتى",
                    "cancallationBeCharged": "سيتم الدفع",
                    "ifYouCancelBetween": "إذا قمت بالإلغاء من",
                    "ifYouCancelModifiedBetween": "إذا قمت بالإلغاء أو التعديل بعد",
                    "cancelFullPrice": "سيتم دفع السعر الكامل للحجز",
                    "till": "حتى",
                    "rateNonRefundable": "السعر غير قابل للاسترداد عند الإلغاء"
                }
            },
            "boards": {
                "RO": "غرفة فقط",
                "BB": "إفطار وسرير",
                "HB": "نصف إقامة",
                "FB": "إقامة كاملة",
                "AI": "كل شيء مشمول",
                "UI": "كل شيء مشمول ديلوكس",
                "BF": "إفطار بوفيه",
                "KB": "بوفيه إفطار بارد",
                "KBB": "Kosher Breakfast",
                "CB": "إفطار قاري",
                "AB": "إفطار أمريكي",
                "DR": "عشاء وغرفة",
                "EB": "إفطار إنجليزي",
                "FT": "FB+علاجات",
                "F+": "إقامة كاملة بلس",
                "GA": "عشاء احتفالي",
                "H6": "HB+6 علاجات فقط",
                "HT": "HB+علاجات",
                "IB": "إفطار إسرائيلي",
                "KO": "كوشر",
                "KS": "إفطار كوشر",
                "MI": "كل شيء مشمول ماكس",
                "RB": "غرفة وإفطار",
                "NN": "انظر الجدول",
                "SI": "كل شيء مشمول ناعم",
                "UL": "كل شيء مشمول ألترا",
                "half_board": "نصف إقامة",
                "half_board_kosher": "نصف إقامة كوشر",
                "full_board": "إقامة كاملة",
                "sleep_only": "غرفة فقط",
                "breakfast_kidush": "وجبة الصباح والمساء يوم الجمعة",
                "breakfast": "BB",
                "breakfast-for-2": "BB لشخصين",
                "nomeal": "غرفة فقط"
            },
            "activitiesTranslations": {
                "addToOrder": "إضافة إلى الطلب",
                "passenger": "إلى الراكب",
                "showMore": "عرض المزيد",
                "addAttractionsAndTrips": "إضافة جذب ورحلات",
                "doYouWantToAddAttractions": "هل تريد إضافة جذب لإجازتك؟",
                "itsTime": "حان الوقت!",
                "pricePerPerson": "السعر لكل شخص"
            },
            "modal": {
                "viewAllImages": "عرض جميع الصور",
                "galleryTitle": "معرض الصور",
                "cancelationTerms": "شروط الإلغاء -",
                "nameOfTheHotel": "تفاصيل الفندق",
                "hotelInfo": "حول الفندق",
                "hotelWebsite": "رابط موقع الفندق",
                "showMore": "عرض المزيد",
                "showLess": "عرض أقل"
            },
            "manageBaggage": {
                "manageBaggage": "إدارة الأمتعة",
                "and": "و",
                "save": "حفظ",
                "purchaseIsNotSupported": "الشراء غير مدعوم",
                "baggageIsForBothFlights": "يمكنك إضافة أمتعة لرحلة ذهاب وعودة",
                "suitcase": "حقيبة",
                "trolly": "عربة",
                "guest": "ضيف"
            },
            "shoppingCartTranslations": {
                localInventoryAlert:"اطلب مع باقة خاصة، غير مدعومة حاليًا للعرض - فقط للدفع",
                skyInventory:"مخزون SKY",
                recommendedHotel:"الفندق الموصى به",
                recommendedFlight:"الرحلة الموصى بها",
                "dynamicPackageTitleRemark": "السعر يشمل الرحلة والفندق - يتم تحديد حقوق وشروط كل منتج على حدة",
                "dynamicPackageTitleRemarkEvents": "السعر يشمل الرحلة والفندق والفعالية - يتم تحديد حقوق وشروط كل منتج على حدة",
                "productIsApproved": "تمت الموافقة على هذا المنتج",
                "productIsNotApproved": "لم تتم الموافقة على هذا المنتج",
                "waitingToApprove": "هذا المنتج قيد المعالجة",
                "productIsCancelled": "تم إلغاء هذا المنتج",
                "orderIsApproved": "تمت الموافقة على هذا الطلب!",
                "orderIsNotApproved": "لم تتم الموافقة على هذا الطلب!",
                "orderBeingProcessed": "هذا الطلب قيد المعالجة",
                "orderIsCancelled": "تم إلغاء هذا الطلب!",

                "attractionPriceDescription": "سعر المعلم يعتمد على التاريخ، اختيار الخيار وعدد التذاكر",
                "selectedDate": "التاريخ المحدد",
                "selectADate": "اختر تاريخاً",
                "availableDatesBetween": "التواريخ المتاحة بين",
                "Options": "الخيارات",
                "Text": "نص",
                "Ticket type": "نوع التذكرة",
                "Start Time": "وقت البدء",
                'Guide language': 'لغة الدليل',
                "Pick Up Location": "مكان الاستلام",
                "Custom Pick Up Location": "مكان الاستلام المخصص",
                "Drop Off Location": "مكان التوصيل",
                "Custom Drop Off Location": "مكان التوصيل المخصص",
                "manageBaggage": "إدارة الأمتعة",
                "youCanAddGuestsOnlyUpToTheAvailableSeats": "يمكنك إضافة ضيوف فقط حتى المقاعد المتاحة",
                "paxExceedsAuthorizedSeats": "عدد الركاب يتجاوز عدد المقاعد المصرح بها بهذا السعر – يرجى الملاحظة أن الحجز سيكون بطلب وأن السعر قابل للتغيير",
                "paxExceedsAvailableSeats": "عدد الركاب يتجاوز عدد المقاعد المتاحة – يرجى الملاحظة أن الحجز سيُقدَّم بانتظار موافقة المزوّد وأن السعر قد يتغير",
                "shoppingCartButtonTooltip": "اختر تكويناً وأضف إلى الطلب",
                "totalPrice": "المبلغ الإجمالي",
                "proceedToPayment": "المتابعة للدفع",
                "placeOrder": "المتابعة للتسجيل",
                "NoHotelWasChosenForTheVacation": "لم يتم اختيار فندق للإجازة",
                "betweenDates": "بين التواريخ",
                "packageInformation": "تفاصيل الحزمة",
                "rooms": "تفاصيل الغرف",
                "transfers": "النقل",
                "round_trip_transfers": "خدمة التوصيل من وإلى الفندق (ذهاب وعودة)",
                "reg_transfers": "نقل/مكوك من وإلى الفندق",
                "shuttle_transfers": "مكوك من الحدود إلى الفندق والعودة",
                "flights": "الرحلات",
                "activities": "المعالم",
                "details": "التفاصيل",
                "shoppingCart": "عربة التسوق",
                "package": "ليالي في الفندق",
                "nights": "ليالي",
                "inHotel": "في الفندق",
                "apply": "تأكيد",
                "promoCode": "كود الخصم",
                "yourShoppingCart": "عربة التسوق الخاصة بك",
                "isEmpty": "ما زالت فارغة...",
                "myVacation": "إجازتي",
                "showAll": "عرض الكل »",
                "beforeDiscount": "الإجمالي قبل الخصم -",
                "agentCommission": "عمولة الوكيل -",
                "agentCommissionNet": "عمولة الوكيل (الدفع الصافي) -",
                "discountFromCode": "خصم من الكود -",
                "affiliateWith": "بالتعاون مع -",
                "tpId": "معرف الطلب -",
                "chargeTypeFullCC": "الدفع الكامل - بما في ذلك العمولة",
                "chargeTypeNetCC": "الدفع الصافي للسعر",
                "chargeTypeCash": "معاملة نقدية",
                "agentCommissionPrec": "نسبة عمولة الوكيل",
                "priceOff": "الخصم",
                "percentageOff": "نسبة الخصم",
                "selectedItems": "العناصر المختارة",
                "viewProduct": "عرض المنتج",
                "infantAdditionalPrice": "سعر إضافي للرضيع",
                "netPriceWarning": "السعر الصافي، يرجى إضافة الربح!",
                "copyOrderLink": "نسخ الرابط",
                "createOrder": "حفظ العرض",
                "createOrderError": "فشل حفظ العرض، يرجى المحاولة مرة أخرى",
                "updateCommission": "حفظ",
                "commissionNotSaved": "الرجاء الضغط للحفظ!",
                "clearCart": "انقر لإفراغ السلة",
                "assignCustomer": "تعيين العميل",
                "firstName": "الاسم الأول",
                "lastName": "الاسم الأخير",
                "phone": "الهاتف",
                "comment": "تعليق",
                "email": "البريد الإلكتروني",
                "wrongEmailFormat": "تنسيق البريد الإلكتروني غير صحيح",
                "saveCustomer": "حفظ العميل",
                "updateCustomerTitle": "تحديث بيانات العميل",
                "createCustomerTitle": "إنشاء عميل جديد",
                "avgPricePerPerson": "أضف متوسط السعر للشخص",
                "avgPricePerPersonLine": "متوسط السعر للشخص",
                "totalPaxLabel": "عدد المسافرين",
                "sendByWhatsApp": "إرسال عبر WhatsApp",
                "copyText": "نسخ النص",
                "copyQuoteTakanonLine": "يرجى التأكد من أنك قرأت ووافقت على الشروط والأحكام قبل الشراء\nرابط الشروط والأحكام: {domain}/takanon",
                "copyWithOrgDays": "نسخ العرض الكامل مع معلومات الأيام",
                "orgItineraryHeader": "مسار الأيام",
                "orgTourPackageLine": "رحلة منظمة إلى {destination}, اسم الرحلة: {tourName}, {nights}, {dateStart} - {dateEnd}",
                "packageToDestinationLine": "باقة عطلة إلى {destination}",
                "sendBySMS": "إرسال عبر SMS",
                "findQuoteFor": "إرسال العرض عبر",
                "linkIsGive": "العرض متاح",
                "dates": "التواريخ",
                "hotelName": "اسم الفندق",
                "flightPrice": "سعر الرحلة",
                "suitcase": "حقيبة",
                "trolly": "عربة",
                "passengers": "الركاب",
                "totalAgentComm": "إجمالي عمولة الوكيل",
                "agentOptions": "خيارات الوكيل",
                "compareDisableForAgent": "مقارنة الأسعار متاحة عند وجود عرضين في السلة",
                "createNewUser": "إنشاء عرض جديد",
                "comparePrice": "مقارنة الأسعار",
                "send": "إرسال العرض",
                "profitPercentageChange": "تغيير نسبة الربح",
                "or": "أو",
                "approval": "الموافقة",
                "profitPerPerson": "الربح لكل شخص",
                "grossProfitPercentage": "نسبة الربح الإجمالية",
                "grossProfitPercentageInvalidRange": "يجب أن تكون نسبة الربح بين 0 و 99",
                "actionNotAllowed": "الإجراء غير مسموح",
                "orderIsAlreadySaved": "الطلب محفوظ بالفعل ولا يمكن إضافة منتجات إضافية",
                "clickToClear": "انقر لإفراغ السلة",
                "unableToAddRoomToSamePackage": "لا يمكن إضافة الغرفة إلى نفس الحزمة",
                "roomsByRequestSubjectOfHotelAvailability": "لا يمكن إضافة نفس نوع الغرفة، يرجى اختيار نوع مختلف من الغرف",
                "roomApprovalIsSubjectToRoomAvailability": "الموافقة على الغرفة تعتمد على توفر الغرف",
                "roomsByRequestSubjectOfHotelAvailabilityTitle": "فشل في إضافة الغرفة",
                "youReachedMaxRooms": "لقد وصلت إلى الحد الأقصى من الغرف",

                "eventTicketAlreadyAdded": "لا يمكن إضافة نفس نوع التذكرة، يرجى اختيار نوع مختلف من التذاكر",
                'failedToAddEventTicket':"فشل في إضافة التذكرة الرياضية",
                "eventTicketPaxMismatchTitle": "عدد التذاكر والركاب غير متطابق",
                "eventTicketPaxMismatch": "عدد تذاكر الحدث المحددة لا يتطابق مع عدد الركاب (الرحلة/الغرفة). يرجى تحديث كمية التذاكر أو اختيار الغرفة.",

                "attractionAlreadyAdded": "لا يمكن إضافة نفس نوع المعلم، يرجى اختيار نوع مختلف من المعلم",
                "failedToAddAttraction": "فشل في إضافة المعلم",
                "noAvailabilityOnThisDates": "لا توجد توافر للتواريخ المحددة",
                "attractionSearchFailed": "فشل البحث عن المعالم",
                "cannotSearchForThePastDates": "لا يمكن البحث عن التواريخ الماضية",
                "searchOtherForDates": "لا توجد توافر، يرجى البحث عن تواريخ متاحة أخرى",
                "adult": "بالغ",
                "child": "طفل",
                "infant": "رضيع",
                "perPerson": "لكل شخص",
                "perVehicle": "لكل مركبة",
                "group": "مجموعة",
                "family": "عائلة",
                "perEquipment": "لكل معدة",
                "perBoat": "لكل قارب",
                "none": "لا شيء"
            },
            "checkout": {
                "cityOfBirth": "مدينة الميلاد",
                "nationalityCountryId": "بلد الجنسية",
                "fill_out_at_least_one_guest_fields": "يرجى ملء جميع الحقول على الأقل لأحد الضيوف!",
                "addRestOfGuests": "Add Rest Of Guests",
                "hideRestOfGuests": "Hide Rest Of Guests",
                "addBaggage": "إضافة أمتعة",
                "newGuest": "ضيف جديد",
                "selectGuest":"اختر ضيف",
                "chooseExistingGuest": "استخدم ضيف موجود",
                "additionalBaggage": "أمتعة إضافية",
                "free": "مجانا",
                "baggageIsForBothFlights": "يمكنك إضافة أمتعة لرحلة الذهاب والعودة",
                "additionalBaggageForThisGuest": "أمتعة إضافية لهذا الضيف",
                "orderFailedToLoad": "حدث خطأ أثناء تحميل العرض",
                "cartNoLongerValid": "السلة لم تعد صالحة",
                "room": "غرفة",
                "personalInfo": "تفاصيل الطلب",
                "paymentDetails": "الدفع",
                "orderCompletion": "إنهاء الطلب",
                "userDetails": "معلومات العميل",
                "name": "الاسم الأول",
                "lastName": "اسم العائلة",
                "passport": "جواز السفر",
                "birthdate": "تاريخ الميلاد",
                "phone": "الهاتف",
                "email": "البريد الإلكتروني",
                "notesForTheOrder": "ملاحظات حول الطلب",
                "namesOfGuests": "المسافرون",
                "namesMustMatchPassport": "* يجب أن تتطابق جميع الأسماء مع ما هو موجود في جواز السفر باللغة الإنجليزية",
                "goToPayments": "إرسال والمتابعة للدفع",
                "saveAndCommit": "حفظ والالتزام بالعرض",
                "saveAndPayLater": "حفظ والدفع لاحقًا",
                "saveOrder": "حفظ الطلب",
                "agreement": "أوافق على شروط الموقع وشروط الطلب وشروط إلغاء الطلب",
                "men": "ذكر",
                "women": "أنثى",
                "pleaseInputYourPhone": "يرجى إدخال رقم هاتفك",
                "pleaseInputYourLastName": "يرجى إدخال اسم عائلتك",
                "pleaseInputYourFirstName": "يرجى إدخال اسمك الأول",
                "pleaseInputYourEmail": "يرجى إدخال بريدك الإلكتروني",
                "pleaseInputYourPassportNumber": "يرجى إدخال رقم جواز سفرك",
                "pleaseInputYourDateOfBirth": "يرجى إدخال تاريخ ميلادك",
                "pleaseSelectGender": "يرجى اختيار الجنس",
                "maxChildAge": "الطفل بين سن 2-",
                "maxInfantAge": "يجب أن يكون الرضع دون سنتين في وقت الإجازة",
                "pleaseAgreeWithT&C": "يرجى الموافقة على شروط الاستخدام ولوائح الموقع",
                "viewTerms": "عرض اللوائح",
                "invalidEmail": "بريد إلكتروني غير صالح",
                "orderCreateSuccess": "تم حفظ طلبك بنجاح، سيتم توجيهك للدفع",
                "orderCreateFree": "تم حفظ طلبك بنجاح!",
                "orderUpdateSuccess": "تم تحديث طلبك بنجاح!",
                "mainRoomGuestTitle": "غرفة باسم",
                "uploadPassportImage": "تحميل صورة جواز السفر",
                "addInfant": "إضافة رضيع",
                "updateInfant": "تحديث عدد الرضع",
                "howManyInfantsDoYouWantToAdd": "اختر عدد الرضع لهذه الغرفة",
                "add": "إضافة",
                "setInfantCountForRoom": "تحديث عدد الرضع",
                "setInfantCountForRoomSuccess": "تم تحديث عدد الرضع بنجاح",
                "infantsAddedToTheRoom": "تم إضافة رضع إلى الغرفة",
                "selectNumberOfInfants": "اختر عدد الرضع",
                "pricePerInfant": "السعر لكل رضيع",
                "infantsRemoved": "تم إزالة الرضع من هذه الغرفة",
                "requiredUploadPassportImage": "تحميل صورة جواز السفر إلزامي",
                "infantError4403": "لا يمكن تغيير عدد الرضع - يرجى الاتصال بمركز الخدمة",
                "docketId": "* رقم الدوكيت",
                "agencyId": "* رقم الوكالة",
                "documentType": "نوع الوثيقة",
                "documentTypeInfo": "اختر بطاقة الهوية للرحلات الداخلية",
                "documentTypePassport": "جواز السفر",
                "documentTypeIdCard": "بطاقة الهوية",
                "issuingCountry": "بلد الإصدار",
                "residenceCountry": "بلد الإقامة",
                "nationality": "الجنسية",
                "documentNumber": "رقم الوثيقة",
                "documentNumberPassport": "رقم جواز السفر",
                "documentNumberIdCard": "رقم بطاقة الهوية",
                "pleaseInputPassportNumber": "يرجى إدخال رقم جواز السفر",
                "pleaseInputIdCardNumber": "يرجى إدخال رقم بطاقة الهوية",
                "expirationDate": "تاريخ انتهاء الصلاحية",
                "pleaseSelectDocumentType": "يرجى تحديد نوع الوثيقة",
                "pleaseSelectIssuingCountry": "يرجى تحديد بلد الإصدار",
                "pleaseSelectResidenceCountry": "يرجى تحديد بلد الإقامة",
                "pleaseSelectNationality": "يرجى تحديد الجنسية",
                "pleaseInputDocumentNumber": "يرجى إدخال رقم الوثيقة",
                "pleaseSelectExpirationDate": "يرجى تحديد تاريخ انتهاء الصلاحية"
            },
            "manageOrder": {
                moveToPaymentWarning: 'لم يتم حفظ معلومات العميل ومعلومات الضيوف فارغة! هل أنت متأكد أنك تريد المتابعة؟',
                moveToPaymentWarning1: 'لم يتم حفظ معلومات العميل. هل أنت متأكد أنك تريد المتابعة؟',
                moveToPaymentWarning2: 'معلومات الضيوف فارغة! هل أنت متأكد أنك تريد الانتقال إلى الدفع؟',
                "questions": "أسئلة",
                "moveToPayment": "إضافة دفعة",
                "backToManage": "العودة لإدارة الطلب",
                "paymentTitle": "دفع الطلب",
                "manageTitle": "تحديث معلومات الطلب",
                "modelNotFound": "الطلب غير موجود",
                "failToLoad": "تعذر تحميل تفاصيل طلبك، يرجى المحاولة مرة أخرى لاحقاً.",
                "orderId": "إدارة الطلب",

                "room_booking_cancelled_successfully": "تم إلغاء حجز الغرفة بنجاح",
                "room_booking_cancel_error": "حدث خطأ أثناء إلغاء حجز الغرفة",
                "cancel_room_booking_warning": "بإلغاء الغرفة، ستفقد الحجز والسعر. هل أنت متأكد؟",
                "cancel_booking": "إلغاء الحجز",
                "incompleteDPsWereRemoved": 'تمت إزالة الباقات الديناميكية غير المكتملة من سلة التسوق الخاصة بك. يرجى إضافتها مرة أخرى مع كل من الفندق+الرحلة وتذاكر الحدث.',
            },
            "attractionQuestions": {
                "customerInfo": "معلومات العميل",
                "participantsInfo": "معلومات المشاركين",
                "first_name": "الاسم الأول",
                "last_name": "اسم العائلة",
                "email_address": "عنوان البريد الإلكتروني",
                "phone_number": "رقم الهاتف",
                "pickup_location": "موقع الاستلام",
                "height_in_centimeters": "الطول بالسنتيمترات",
                "weight_in_kilograms": "الوزن بالكيلوغرامات"
            },
            "completionForm": {
                "paymentFinish": {
                    "title": "تم الطلب بنجاح - تم الدفع",
                    "info": "تم إرسال بريد إلكتروني بتفاصيل الطلب إلى عنوانك"
                },
                "waitingToApprove": {
                    "title": "تم إرسال طلبك للموافقة",
                    "info1": "تم حفظ تفاصيل الطلب في النظام وأرسل للموافقة.",
                    "info2": "سيتم الدفع فقط بعد الموافقة على الطلب.",
                    "info3": "سيتم إرسال بريد إلكتروني بتأكيد الطلب والدفع بعد الموافقة."
                },
                "paymentFail": {
                    "title": "فشل الدفع",
                    "info1": "فشل الدفع :(",
                    "infoFail": "بعد عدة محاولات، فشل الشحن - يرجى المحاولة مرة أخرى",
                    "infoWhatsapp": "إذا حدث خطأ ولا يمكنك الدفع، يرجى الاتصال عبر WhatsApp على:"
                },
                "orderNum": "رقم الطلب",
                "thanksForChoose": "شكرًا لاختيارك",
                "free": {
                    "title": "تم التسجيل بنجاح",
                    "info": "تم إرسال بريد إلكتروني مع ملخص الطلب إليك"
                },
                "pay_later": {
                    "title": "تم التسجيل بنجاح",
                    "info": "تم إرسال بريد إلكتروني بتأكيد الطلب إليك"
                }
            },
            "paymentForm": {
                "card": "بطاقة الائتمان",
                "creditCardInterest": "فائدة بطاقة الائتمان",
                "interest": "فائدة",
                "monthlyPayments": "الدفعات الشهرية",
                "monthsCount": "عدد الشهور",
                "priceCanNotBeOverBalance": "السعر لا يمكن أن يتجاوز الرصيد",
                "total": "الرابط الكلي",
                "balance": "الرصيد الكلي",
                "updatedBalance": "الرصيد المُحدث",
                "copyLink": "نسخ الرابط",
                "linkFor": "رابط لـ",
                "back": "عودة",
                "setSpecificPrice": "رابط الدفع",
                "createLink": "إنشاء رابط",
                "setPriceAndSendPaymentLinkToClient": "تحديد السعر وإرسال رابط الدفع للعميل",
                "clientName": "اسم العميل",
                "paymentPageFor": "صفحة الدفع لـ",
                "forPayment": "للدفع",
                "price": "السعر",
                "copyPaymentLink": "نسخ رابط الدفع",
                "pleaseFillInBothFields": "يرجى ملء كلا الحقلين.",
                "paymentLinkCopiedToClipboard": "تم نسخ رابط الدفع إلى الحافظة!",
                "createLinkForPrice": "إنشاء رابط للدفع",
                "creditNotSaveInBd": "تفاصيل بطاقة الائتمان لا تُحفظ على الموقع - أنت تقوم بعملية دفع آمنة",
                "title": "أدخل طريقة الدفع (فيزا وماستركارد فقط)",
                "splitBtn": "اضغط لتقسيم بطاقات الائتمان",
                "splitTitle": "تقسيم بطاقات الائتمان",
                "splitDesc": "اختر عدد بطاقات الائتمان للتقسيم واضغط تأكيد",
                "noSplit": "بدون تقسيم",
                "noPayments": "بدون دفعات",
                "payments": "الدفعات",
                "paymentsNum": "عدد الدفعات",
                "withDebit": "باستخدام الائتمان",
                "splitBy": "بطاقات الائتمان",
                "toPay": "للدفع",
                "splitApprove": "تأكيد",
                "currencyRate": "التحصيل بالشواكل - حسب سعر السياحة",
                "splitCurrentCardNum": "تقسيم الائتمان",
                "splitCurrentCardNumFrom": "من أصل",
                "errorMessageToRetry": "محاولة رقم {retryNum} - فشل الدفع من شركة بطاقة الائتمان. يرجى إدخال تفاصيل بطاقة أخرى. الموقع يقبل بطاقات فيزا وماستركارد فقط.",
                "installments": "الأقساط",
                "installmentsLabel": "عدد الأقساط",
                "installmentFee": "رسوم الأقساط",
                "totalToPay": "المبلغ الإجمالي للدفع",
                "perMonth": "شهرياً",
                "installmentsDisclosure": "يتم معالجة الأقساط من قبل مصدر بطاقتك. المبلغ الإجمالي يتضمن رسوم الأقساط."
            },
            "hotelTypes": {
                "Hotel": "فندق"
            },
            "hotelDetails": {
                "updateDates": "تحديث التواريخ",
                "roomTypesToChooseFrom": "أنواع الغرف للاختيار من بينها",
                "metapolicy": "سياسة الفندق",
                "metaExtraInfo": "معلومات إضافية",
                "not_included": "غير مشمول",
                "included": "مشمول",
                "price": "بتكلفة",
                "address": "العنوان",
                "Location": "موقع الفندق",
                "At the boutique hotel": "حول الفندق",
                "Room amenities": "مرافق الغرفة",
                "parking": "موقف سيارات",
                "pets": "الحيوانات الأليفة",
                "shuttle": "النقل إلى المطار (ذهاب فقط)",
                "internet": "خدمات الإنترنت",
                "extra_bed": "سرير إضافي",
                "add_fee": "رسوم إضافية",
                "children_meal": "وجبة الأطفال",
                "check_in_check_out": "تسجيل الوصول والمغادرة"
            },
            "sideFilters": {
                "sortBy": "فرز بحسب",
                "price_asc": "السعر الأقل",
                "price_desc": "السعر الأعلى",
                "hotel_stars_asc": "النجوم الأقل",
                "hotel_stars_desc": "النجوم الأعلى",
                "distance": "المسافة",
                "distance_asc": "المسافة الأقرب",
                "distance_desc": "المسافة الأبعد",
                "recommended": "موصى به",
                "price": "السعر",
                "clearSideFilters": "مسح الفلاتر",
                "ts_type": "أنواع الرحلات",
                "auto_approve": "الموافقة الفورية",
                "include_transfer": "تشمل النقل",
                "include_baggage": "تشمل الأمتعة",
                "include_trolly": "تشمل عربة",
                "auto_approve_checked": "عرض نتائج الموافقة الفورية",
                "from_date_hours": "وقت الرحلة الصادرة",
                "isSpecial": "هل هو خاص؟",
                "is_special": "هل هو خاص؟",
                "date_range": "مدة الإقامة",
                "from_date_landing_hours": "وقت الرحلة الصادرة",
                "flight_stop_time": "وقت التوقف",
                "return_date_landing_hours": "وقت الرحلة العائدة",
                "return_date_hours": "وقت الرحلة العائدة",
                "airline": "شركة الطيران",
                "2": "رحلات مستأجرة",
                "3": "رحلات مجدولة",
                "nonStop": "رحلة مباشرة",
                "stop": "توقف واحد",
                "stops_plural": "توقفات",
                "hotel_type": "أنواع الإقامة",
                "stops": "عدد التوقفات",
                "freeCancellation": "إلغاء مجاني؟",
                "freeCancellationLabels": {
                    "1": "إلغاء مجاني فقط",
                    "0": "بدون إلغاء مجاني"
                },
                "feature": "ميزة",

                "event_type": "أنواع الأحداث",
                "avenue": "الشارع",
                "event_date": "تاريخ الحدث",
            },
            "package_feature": {
                "SPECIAL PACKAGE": "حزمة خاصة",
                "ALL PACKAGES": "جميع الحزم",
                "KOSHER": "كوشر",
                "SKI": "تزلج",
                "EVENT": "فعالية",
                "SPORT": "رياضة",
                "SPA": "سبا",
                "YOUNG VACATION": "إجازة للشباب",
                "FLT+HTL+CAR": "FLT+HTL+CAR"
            },
            "general": {
                "km": "كم",
                "kmFromVenue": "كم من المكان",
                "kmFromCityCenter": "كم من المركز المديني",
                openBO: "فتح النظام الخلفي",
                logOut: "تسجيل الخروج",
                "toOrder": "إلى الطلب",
                "amount": "المبلغ",
                parentOriginal: "الأصل من الموقع الأب",
                parentEdited: "تم التعديل من الموقع الأب",
                "fetchingMoreResults": "جارٍ تحميل المزيد من النتائج...",
                "error": "خطأ",
                "somethingWentWrong": "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
                "noResultsFound": "لم يتم العثور على أي فعاليات",
                "tryAdjustingFilters": "حاول تعديل الفلاتر أو معايير البحث",
                "refresh": "تحديث",
                "list": "قائمة",
                "matched": "مطابقة",
                "sameRates": "الأسعار المتطابقة",
                "rates": "الأسعار",
                "calculatedRates": "الأسعار المحسبة",
                "to": "إلى",
                "roomOnly": "غرفة فقط",
                "totalPrice": "السعر الإجمالي",
                "close": "إغلاق",
                "attraction": "معلم",
                "includeReturnSuitcase": "شمل حقيبة للرحلة العودة",
                "total": "المجموع",
                "as_of_today": "حتى اليوم",
                "priceInIls": "({price} ₪)",
                "link_to_the_offer": "رابط العرض",
                "the_quote_has_been_copied_successfully": "تم نسخ العرض بنجاح",
                "base": "أساس",
                "sort": "ترتيب",
                "submit": "إرسال",
                "maxAmountOf": "الحد الأقصى للمبلغ من",
                "minAmountOf": "الحد الأدنى للمبلغ من",
                "ticketType": "نوع التذكرة",
                "cancellation_policy": "سياسة الإلغاء",
                "additionalInfo": "معلومات إضافية",
                "hour": "ساعة",
                "minute": "دقيقة",
                "before": "قبل",
                "date": "التاريخ",
                "duration": "المدة",
                "quantity": "الكمية",
                "tickets": "التذاكر",
                "deliveryMethod": "طريقة التوصيل",
                "for": "لـ",
                "free": "مجاناً",
                "freeOfCharge": "مجاناً",
                "option": "خيار",
                "removeSelection": "إلغاء الاختيار",
                "grandTotalPrice": "المجموع الكلي",
                "startingPrice": "سعر البداية",
                "usd": "دولار أمريكي",
                "euro": "يورو",
                "address": "العنوان",
                "type": "النوع",
                "noResults": "لا نتائج",
                "boardBasis": "أساس الإقامة",
                "nights": "ليالي",
                "supplier": "المورد",
                "airLine": "شركة الطيران",
                "price": "السعر",
                "totalRoomPrice": "السعر الكلي للغرفة",
                "priceForXRooms": "السعر لـ X غرف",
                "hotel": "فندق",
                "hotel_stars": "نجوم الفندق",
                "minPrice": "السعر الأدنى",
                "BB": "إفطار وسرير",
                "HB": "نصف إقامة",
                "cancel": "إلغاء",
                "replaceShoppingCart": "استبدال سلة التسوق",
                "replace": "استبدال",
                "searchForUser": "البحث عن مستخدم",
                "acceptCookiesTitle": "يستخدم هذا الموقع ملفات تعريف الارتباط لضمان حصولك على أفضل تجربة على موقعنا.",
                "acceptCookiesBtn": "قبول",
                "includesActivities": "{NUMBER} من الأنشطة كهدية!",
                "includesActivity": "يشمل نشاط كهدية!",
                "adults": "بالغين",
                "all_include": "كل شيء مشمول",
                "breakfast": "إفطار",
                "half_board": "نصف إقامة",
                "half_board_kosher": "نصف إقامة كوشر",
                "full_board": "إقامة كاملة",
                "sleep_only": "إقامة فقط",
                "breakfast_kidush": "إفطار وعشاء الجمعة",
                "addToCard": "إضافة إلى الطلب",
                "chooseRoom": "اختيار التركيبة والغرفة",
                "boardType": "أساس الإقامة",
                "filters": "مرشحات",
                "rating": "تقييم الفندق",
                "event": "فعالية",
                "attraction_stars": "تقييم المعلم",
                "selected": "محدد",
                "name": "الاسم",
                "taxonomies": "التصنيفات",
                "children": "أطفال",
                "toDate": "حتى",
                "transfers": "النقل",
                "from": "من",
                "perPerson": "لكل شخص",
                "perPax": "لكل فرد",
                "include": "يشمل",
                "noIncludeText": "حزم العطلات",
                "flights": "رحلات جوية",
                "vacationAt": "عطلة في {DEST}",
                "fieldRequired": "حقل إلزامي",
                "showAll": "عرض الكل",
                "showLess": "عرض أقل",
                "flight": "رحلة",
                "h": "س",
                "min": "دق",
                "availableSeats": "المقاعد المتوفرة",
                "showGrossPrice": "عرض السعر الإجمالي",
                "showNetPrice": "عرض السعر الصافي",
                "noRating": "بدون تقييم",
                "bundleFlight": "رحلة ذهاب وعودة",
                "oneWayBundleFlight": "رحلة في اتجاه واحد",
                "trollyIsIncluded": "تشمل عربة",
                "trollyIsNotIncluded": "بدون عربة",
                "suitcaseIsIncluded": "تشمل حقيبة",
                "suitcaseIsNotIncluded": "بدون حقيبة",
                "additionalSuitcases": "يشمل X حقائب",
                "additionalTrolly": "يشمل X عربات",
                "returnFlight": "رحلة العودة",
                "outboundFlight": "رحلة الذهاب",
                "agentMode": "وضع الوكيل",
                "userMode": "وضع العميل",
                "suitcase": "حقيبة",
                "trolly": "عربة",
                "packageSearchResult": "الحزم التي وجدناها لك",
                "day": "يوم",
                "selectDate": "اختر التواريخ",
                "search": "بحث",
                "adult": "بالغ",
                "child": "طفل",
                "infant": "رضيع",
                "infants": "رضع",

                "loading": "جارٍ التحميل",
                "showingMoreResults": "عرض المزيد من النتائج",
                "noMoreResults": "لا توجد نتائج أخرى",
                "NoResultsMatchedTheFilterValues": "لم تتطابق أي نتائج مع قيم الفلتر",
                "eventTicketsAdded": "تمت إضافة تذاكر الحدث",
                "addEventTickets": "إضافة تذاكر الحدث",
                "remove": "إزالة",
            },
            "subsidizedForm": {
                "title": "إضافة دعم",
                "employee_id": "رقم الموظف",
                "person_id": "رقم الهوية (9 أرقام)",
                "validate": "تحقق من كود الموظف",
                "alreadyApplied": "الدعم مطبق بالفعل",
                "addOneMore": "إضافة دعم آخر",
                "addOneMoreId": "إضافة موظف آخر",
                "fieldRequired": "حقل إلزامي",
                "priceReducedBy": "تم تخفيض السعر بمقدار",
                "forEmployee": "للموظف",
                "employeeIs": "تم التعرف بنجاح",
                "error4401": "فشل التعرف، حاول مجدداً",
                "error4402": "تم التعرف على الكود، لكنه مستخدم بالفعل",
                "guestIdentifiedId": "تم التعرف بواسطة الهوية",
                "guestNotIdentified": "يجب التعرف قبل التسجيل",
                "clickToIdentify": "انقر للتعرف"
            },

            "uploadImage": {
                "uploadPassportImage": "تحميل صورة جواز السفر",
                "somethingWentWrong": "حدث خطأ ما"
            },
            "flightButton": {
                "no_availability_for_this_flight_price": "عذرًا، لا توجد مقاعد متوفرة لهذه الأسعار",
                "cardConditions": "شروط البطاقة",
                "flightTotalPrice": "سعر الرحلة لاتجاه واحد",
                "total": "المجموع",
                "continueToOrder": "الانتقال إلى الطلب",
                "addToCart": "إضافة إلى السلة",
                "lastPlace": "آخر المقاعد المتوفرة",
                "pricePerPassenger": "السعر لكل راكب"
            },
            "agentCommission": {
                "supplier": "المورد",
                "commission": "العمولة",
                "recommendedFee": "الرسوم الموصى بها",
                "transactionDetailsForAgent": "تفاصيل العملية للوكيل",
                "supplierNotes": "ملاحظات المورد",
                "cancellationConditions": "شروط الإلغاء",
                "addToCartToChangeFree": "أضف إلى السلة لتغيير العمولة",
                "pricesShownAreNetPrices": "الأسعار المعروضة هي أسعار صافية",
                "pricesShownAreGrossPrices": "الأسعار المعروضة هي أسعار إجمالية",
                "packageRemarks": "ملاحظات الحزمة"
            },
            "onboarding": {
                "openOnboarding": "دليل",
                "welcomeTitle": "مرحباً بكم في Sky360",
                "subtitle": "استفيدوا من منصتنا بشكل كامل مع هذا الجولة السريعة. أكملوا كل خطوة لاستكشاف كل ما نقدمه.",
                "progressTitle": "تقدمكم",
                "progressLabel": "مكتمل",
                "continueOnboarding": "متابعة",
                "yourPath": "خطوات التهيئة",
                "pathSubtitle": "اتبعوا هذه الخطوات لاستكشاف جميع منتجاتنا.",
                "markAsDone": "وضع علامة كمكتمل",
                "upNext": "التالي",
                "continue": "متابعة",
                "outcomesTitle": "ما ستتعلمونه",
                "outcome1": "البحث والحجز",
                "outcome1Desc": "ابحثوا عن الباقات والرحلات والفنادق والمزيد.",
                "outcome2": "الفعاليات والمعالم",
                "outcome2Desc": "اكتشفوا تجارب محلية في وجهتكم.",
                "stepCompleted": "مكتمل",
                "stepCompletedBanner": "اكتملت الخطوة! أنتم تُحرزون تقدماً رائعاً.",
                "stepCompletionTitle": "اكتملت الخطوة {num}!",
                "stepCompletionKicker": "عمل رائع — واصل الزخم!",
                "tasksCompleted": "المهام: {done}/{total} مكتملة",
                "typeTask": "نفّذ",
                "stepLabel": "خطوة",
                "nextStepHint": "التالي: خطوة {num} — {title}",
                "continueUpNext": "ابدأ",
                "tourFinishBtn": "انتهى",
                "tourNextBtn": "التالي",
                "tourPrevBtn": "السابق",
                "tourActionHint": "👆 انقر على الزر أعلاه للمتابعة",
                "typeLearn": "تعلّم",
                "steps": {
                    "step1": { "title": "البحث عن باقات الإجازة", "description": "تعلموا كيفية البحث عن باقات الإجازة الشاملة وحجزها." },
                    "step2": { "title": "البحث عن رحلات جوية", "description": "ابحثوا عن رحلات ذهاب فقط أو ذهاب وإياب وحددوا التواريخ." },
                    "step3": { "title": "البحث عن فنادق", "description": "تصفحوا الفنادق حول العالم حسب الوجهة والتواريخ." },
                    "step4": { "title": "استكشاف المعالم", "description": "اكتشفوا الأنشطة المحلية والمعالم السياحية في وجهتكم." },
                    "step5": { "title": "البحث عن فعاليات", "description": "تصفحوا الفعاليات القادمة وادمجوها مع رحلة ومبيت." },
                    "step6": { "title": "استعراض محرّك البحث", "description": "التنقل بين جميع أنواع المنتجات من مكان واحد." },
                    "step7": { "title": "البحث عن الباقات الديناميكية", "description": "تعلّموا كيفية بناء رحلة مخصصة باختيار الوجهة أو الفندق وإضافة رحلة طيران مباشرة." },
                    "step8": { "title": "إنشاء حجز رحلة طيران", "description": "اتبع خطوات حجز رحلة الطيران كاملةً — من البحث حتى الدفع." },
                    "step9": { "title": "نظرة عامة على لوحة الوكيل", "description": "لوحة الوكيل في أعلى B2C تتيح لك إدارة العملاء وتبديل أوضاع التسعير وعرض رصيد الماس والمزيد." },
                    "step10": { "title": "إنشاء حجز باقة", "description": "اتبع خطوات حجز الباقة السياحية كاملةً — من البحث حتى الدفع." },
                    "step11": { "title": "استكشاف صفحة إدارة الطلب", "description": "تصفح صفحة إدارة الطلب — راجع تفاصيل الحجز وحدّث بيانات الضيوف وانتقل إلى قسم الدفع." }
                },
                "tour": {
                    "seModHoverTitle": "استكشف إجراءات الوحدة",
                    "seModHoverDesc": "مرّروا المؤشر فوق أي وحدة في الصفحة أدناه — سيظهر شريط إجراءات صغير لتلك الوحدة. مرّروا فوق إحداها الآن للتعرّف على ما يفعله كل إجراء.",
                    "seModAddTopTitle": "إضافة وحدة في الأعلى",
                    "seModAddTopDesc": "يُدرج وحدة جديدة كليًا مباشرة فوق هذه الوحدة. انقروا عليه لاختيار نوع الوحدة ووضعها.",
                    "seModReorderTitle": "إعادة ترتيب هذه الوحدة",
                    "seModReorderDesc": "استخدموا سهمَي الأعلى والأسفل لنقل هذه الوحدة إلى موضع أسبق أو أحدث في الصفحة. تُعاد المعاينة فورًا.",
                    "seModEditTitle": "تحرير هذه الوحدة",
                    "seModEditDesc": "يفتح هذه الوحدة في لوحة الإعدادات على اليسار، حيث يمكنكم تغيير محتواها وتخطيطها وتصميمها.",
                    "seModDeleteTitle": "إزالة هذه الوحدة",
                    "seModDeleteDesc": "يحذف هذه الوحدة من الصفحة. يمكنكم دائمًا إضافتها لاحقًا من خيارات إضافة الوحدة.",
                    "seModAddBottomTitle": "إضافة وحدة في الأسفل",
                    "seModAddBottomDesc": "يُدرج وحدة جديدة كليًا مباشرة أسفل هذه الوحدة — مثل الزر العلوي تمامًا، لكن للموضع السفلي.",
                    "packagesDpSwitchTitle": "الحزم الديناميكية — رحلة + فندق", "packagesDpSwitchDesc": "انتقلوا إلى وضع الحزمة الديناميكية — اختاروا فندقًا وسيقوم النظام بإقرانه مع أرخص رحلة متاحة على المسار، ليخلق سعرًا تنافسيًا وشاملًا للحزمة في الحال.",
                    "packagesFeaturesTitle": "فئات الباقات", "packagesFeaturesDesc": "اختاروا نوع باقة العطلة التي تبحثون عنها — جولات منظمة، رحلات رياضية، سفر كوشير والمزيد.",
                    "pkgSpecialTitle": "الباقات الخاصة — عمولة ثابتة 10%", "pkgSpecialDesc": "هذه هي فئة الباقات الخاصة — باقات سياحة جماعية منسقة تديرها المنصة. تأتي كل باقة خاصة بعمولة وكيل ثابتة 10% مدمجة مسبقاً — رائعة للبيع السريع والمثقة بالثقة دون الحاجة إلى التفاوض على الأسعار.",
                    "pkgOtherCatsTitle": "فئات الباقات الأخرى", "pkgOtherCatsDesc": "هذه هي فئات الباقات الأخرى — جولات منظمة، سفر كوشير، رحلات التزلج، عطلات سبا، فعاليات رياضية والمزيد. تقوم كل فئة بتصفية الباقات المتاحة والوجهات تلقائياً.",
                    "pkgSelectCatTitle": "جربوا — اختاروا فئة", "pkgSelectCatDesc": "انقروا على أي بطاقة فئة لتصفية الباقات حسب النوع. شاهدوا كيف تتحدث قائمة الوجهات تلقائياً لتعرض المواقع المتاحة.",
                    "pkgFilteredDestsTitle": "الوجهات المصفاة", "pkgFilteredDestsDesc": "عند اختيار فئة، يتم تصفية قائمة الوجهات تلقائياً لإظهار المواقع التي تتوفر فيها باقات من هذا النوع. اختاروا وجهة للمتابعة.",
                    "pkgDeselectCatTitle": "انقروا مجدداً لإلغاء الاختيار", "pkgDeselectCatDesc": "النقر مرة ثانية على الفئة النشطة سيلغي اختيارها — وتعود قائمة الوجهات لعرض جميع الباقات المتاحة. جربوا الآن.",
                    "pkgDepartureTitle": "مدينة المغادرة", "pkgDepartureDesc": "اختاروا المطار أو المدينة التي ستغادرون منها في رحلتكم الحزمية.",
                    "packagesDestTitle": "اختر الوجهة", "packagesDestDesc": "حددوا وجهة واحدة أو أكثر لباقة إجازتكم.",
                    "packagesGuestsTitle": "المسافرون", "packagesGuestsDesc": "اختاروا عدد المسافرين — البالغين والأطفال والرضع — لباقة عطلتكم.",
                    "packagesDatesTitle": "تواريخ السفر", "packagesDatesDesc": "حددوا تاريخي المغادرة والعودة للباقة.",
                    "packagesSearchTitle": "البحث عن باقات", "packagesSearchDesc": "انقروا هنا للعثور على الباقات المتاحة.",
                    "flightTripTypeTitle": "نوع الرحلة", "flightTripTypeDesc": "التبديل بين رحلة الاتجاه الواحد وذهاب وإياب.",
                    "flightDirectTitle": "رحلات مباشرة فقط", "flightDirectDesc": "فعّلوا هذا المفتاح لتصفية النتائج لعرض الرحلات المباشرة فقط — بدون توقفات.",
                    "flightDepartureTitle": "مدينة المغادرة", "flightDepartureDesc": "حددوا المطار أو المدينة التي ستغادرون منها.",
                    "flightArrivalTitle": "الوجهة", "flightArrivalDesc": "حددوا المطار أو المدينة التي تريدون السفر إليها.",
                    "flightPaxTitle": "المسافرون", "flightPaxDesc": "حددوا عدد البالغين والأطفال والرضع.",
                    "flightDatesTitle": "تواريخ الرحلة", "flightDatesDesc": "اختاروا تاريخ المغادرة وتاريخ العودة للرحلات ذهاباً وإياباً.",
                    "flightSearchTitle": "البحث عن رحلات", "flightSearchDesc": "انقروا للبحث عن الرحلات المتاحة.",
                    "hotelDestTitle": "وجهة الفندق", "hotelDestDesc": "ابحثوا عن المدينة أو المنطقة للإقامة.",
                    "hotelGuestsTitle": "الغرف والضيوف", "hotelGuestsDesc": "أضيفوا غرفًا بالعدد الذي تحتاجونه وقوموا بإعداد كل غرفة بشكل منفصل — حددوا عدد البالغين والأطفال والرضع في كل غرفة. يمكنكم دمج تكوينات مختلفة لتناسب أي مجموعة: أزواج أو عائلات أو أي تركيبة أخرى.",
                    "hotelDatesTitle": "تسجيل الوصول والمغادرة", "hotelDatesDesc": "حددوا تواريخ الوصول والمغادرة.",
                    "hotelSearchTitle": "البحث عن فنادق", "hotelSearchDesc": "انقروا للبحث عن الفنادق المتاحة.",
                    "attrDestTitle": "مدينة المعلم", "attrDestDesc": "أدخلوا أو اختاروا المدينة للبحث عن معالم وأنشطة.",
                    "attrDatesTitle": "تواريخ النشاط", "attrDatesDesc": "اختاروا نطاق التاريخ للأنشطة.",
                    "attrTypeTitle": "نوع المعلم", "attrTypeDesc": "فلترة حسب الفئة — متاحف، أنشطة خارجية، جولات وغيرها.",
                    "attrSearchTitle": "البحث عن معالم", "attrSearchDesc": "انقروا للبحث عن المعالم المتاحة في المدينة.",
                    "eventsPackageTitle": "تضمين الباقة الكاملة", "eventsPackageDesc": "فعّلوا هذا المفتاح لدمج الفعالية مع رحلة وفندق.",
                    "eventsEventTitle": "البحث عن فعالية", "eventsEventDesc": "أدخلوا اسم الفعالية أو تصفحوا الخيارات المتاحة.",
                    "eventsDatesTitle": "تواريخ الفعالية", "eventsDatesDesc": "حددوا نطاق التواريخ التي تريدون حضور الفعالية فيها.",
                    "eventsSearchTitle": "البحث عن فعاليات", "eventsSearchDesc": "انقروا للبحث عن الفعاليات المتاحة.",
                    "mainTabsTitle": "اختر نوع البحث", "mainTabsDesc": "استخدموا هذه التبويبات للتنقل بين الباقات والرحلات والفنادق والمعالم والفعاليات.",
                    "mainFormTitle": "نموذج البحث", "mainFormDesc": "أدخلوا تفاصيل سفركم — الوجهة والتواريخ والمسافرون — ثم اضغطوا بحث.",
                    "mainPkgTabTitle": "باقات الرحلات", "mainPkgTabDesc": "ابحثوا عن باقات إجازات شاملة تجمع بين الرحلات والفنادق. انقروا على هذا التبويب لرؤية نموذج بحث الباقات.",
                    "mainPkgFormTitle": "نموذج بحث الباقات", "mainPkgFormDesc": "حددوا مدينة المغادرة والوجهة وتواريخ السفر وتكوين الغرف لباقات العطلات. كل حقل يساعد في تضييق الخيارات الأنسب لعملائكم.",
                    "mainFltTabTitle": "الرحلات الجوية", "mainFltTabDesc": "ابحثوا عن رحلات منفردة — ذهاب فقط أو ذهاباً وإياباً. انقروا على هذا التبويب لرؤية نموذج بحث الرحلات.",
                    "mainFltFormTitle": "نموذج بحث الرحلات", "mainFltFormDesc": "اختاروا نوع الرحلة ومدن المغادرة والوصول وتواريخ السفر وعدد المسافرين. فعّلوا 'رحلات مباشرة فقط' لاستبعاد التوقفات.",
                    "mainHtlTabTitle": "الفنادق", "mainHtlTabDesc": "ابحثوا عن إقامات فندقية فقط في جميع أنحاء العالم. انقروا على هذا التبويب لرؤية نموذج بحث الفنادق.",
                    "mainHtlFormTitle": "نموذج بحث الفنادق", "mainHtlFormDesc": "أدخلوا الوجهة وتواريخ الوصول والمغادرة وإعداد الغرف. يمكنكم إضافة غرف متعددة وتكوين كل غرفة بشكل منفصل لمجموعتكم.",
                    "mainAttrTabTitle": "المعالم السياحية", "mainAttrTabDesc": "اكتشفوا الأنشطة المحلية والجولات السياحية والأماكن المثيرة في أي وجهة. انقروا على هذا التبويب لرؤية نموذج البحث.",
                    "mainAttrFormTitle": "نموذج بحث المعالم", "mainAttrFormDesc": "اختاروا المدينة ونطاق التواريخ ونوع النشاط للعثور على الأنشطة المتاحة. رائع لإضافة خيارات إضافية لأي حجز.",
                    "mainEvtTabTitle": "الفعاليات", "mainEvtTabDesc": "احجزوا تذاكر الحفلات الموسيقية والمباريات الرياضية والمهرجانات والمزيد — مع إمكانية حزمة شاملة مع رحلة وفندق. انقروا على هذا التبويب لرؤية النموذج.",
                    "mainEvtFormTitle": "نموذج بحث الفعاليات", "mainEvtFormDesc": "ابحثوا عن الفعاليات حسب الاسم أو الوجهة وحددوا التواريخ. فعّلوا 'حزمة كاملة' لدمج الفعالية مع رحلة وفندق في حجز واحد.",
                    "dynDpSwitchTitle": "رحلة + فندق — حزمة ديناميكية", "dynDpSwitchDesc": "تجمع الحزم الديناميكية بين فندق من اختياركم وأرخص رحلة متاحة على هذا المسار — مما يخلق سعرًا تنافسيًا وشاملًا للحزمة في الحال. يقوم النظام تلقائيًا بتثبيت أفضل سعر للرحلة وإقرانه بنتائج الفندق.",
                    "dynDirectTitle": "رحلة مباشرة", "dynDirectDesc": "عند التفعيل، تقتصر النتائج على الرحلات المباشرة فقط. أوقفوه لتضمين الرحلات مع توقف.",
                    "dynDepartureTitle": "مدينة المغادرة", "dynDepartureDesc": "اختاروا المطار أو المدينة التي ستغادرون منها في رحلتكم الديناميكية.",
                    "dynDestTitle": "الوجهة أو اسم الفندق", "dynDestDesc": "ابحثوا بشكل عام حسب مدينة الوجهة لاستعراض جميع الفنادق المتاحة في المنطقة — أو اكتبوا اسم فندق محدد للانتقال مباشرة إلى ذلك العقار. الانتقال المباشر إلى الفندق أسرع عندما يكون لدى عميلكم تفضيل بالفعل، ويساعدكم على بناء أفضل حزمة في ثوانٍ.",
                    "dynDatesTitle": "تواريخ الإقامة", "dynDatesDesc": "اختاروا تاريخي الوصول والمغادرة للفندق.",
                    "dynGuestsTitle": "الغرف والضيوف", "dynGuestsDesc": "أضيفوا غرفًا بالعدد الذي تحتاجونه وقوموا بإعداد كل غرفة بشكل منفصل — حددوا عدد البالغين والأطفال والرضع لكل غرفة. دمجوا التكوينات لتتوافق مع مجموعة العميل، مثلاً عائلة مع أطفال في غرفة وزوجان في غرفة أخرى.",
                    "dynSearchTitle": "البحث عن باقة ديناميكية", "dynSearchDesc": "انقروا للبحث عن الباقات الديناميكية المتاحة لوجهتكم وتواريخكم وضيوفكم.",
                    "fltSearchActionTitle": "البحث عن رحلة طيران", "fltSearchActionDesc": "أدخلوا تفاصيل السفر وانقروا على بحث لرؤية الرحلات المتاحة.",
                    "fltResOnewayDayTitle": "التنقل السريع بين التواريخ", "fltResOnewayDayDesc": "استخدموا بطاقات الأيام للتنقل السريع إلى تاريخ مغادرة آخر ورؤية الأسعار المحدّثة.",
                    "fltResOnewayFiltersTitle": "تصفية النتائج", "fltResOnewayFiltersDesc": "استخدموا الفلاتر الجانبية لتضييق النتائج حسب شركة الطيران ونطاق السعر وعدد التوقفات والأوقات.",
                    "fltResOnewayCardsTitle": "الرحلات المتاحة", "fltResOnewayCardsDesc": "تصفحوا قائمة الرحلات المتاحة. كل بطاقة تُظهر شركة الطيران ورقم الرحلة والمدة والتوقفات والسعر.",
                    "fltResOnewayActionTitle": "اختاروا رحلتكم", "fltResOnewayActionDesc": "انقروا على «اختر رحلة» في أي بطاقة للانتقال إلى صفحة تفاصيل الحجز.",
                    "fltResBundleTabTitle": "رحلة ذهاباً وإياباً مقابل الديناميكية", "fltResBundleTabDesc": "التنقل بين «اختر رحلاتك بنفسك» — بما يشمل مقاطع مرنة أحادية الاتجاه والتنقل بين التواريخ — و«رحلات محددة مسبقاً» — باقات ذهاباً وإياباً.",
                    "fltResBundleFiltersTitle": "تصفية النتائج", "fltResBundleFiltersDesc": "استخدموا الفلاتر الجانبية لتضييق النتائج حسب شركة الطيران ونطاق السعر وعدد التوقفات والأوقات.",
                    "fltResBundleCardsTitle": "خيارات الرحلات المجمّعة", "fltResBundleCardsDesc": "كل بطاقة تُظهر باقة ذهاباً وإياباً كاملة مع تفاصيل الرحلتين والسعر الإجمالي.",
                    "fltResBundleActionTitle": "الانتقال للطلب", "fltResBundleActionDesc": "انقروا على «الانتقال للطلب» على الرحلة المفضلة لمراجعة التفاصيل وإضافتها إلى السلة.",
                    "fltResBundleResumeActionTitle": "الانتقال للطلب", "fltResBundleResumeActionDesc": "اختاروا رحلة مجمّعة وانقروا على «الانتقال للطلب» للمتابعة.",
                    "fltResDynDayTitle": "التنقل السريع بين التواريخ", "fltResDynDayDesc": "استخدموا بطاقات التواريخ للانتقال السريع إلى تاريخ مغادرة آخر ومعرفة تغيرات الأسعار.",
                    "fltResDynFiltersTitle": "تصفية النتائج", "fltResDynFiltersDesc": "ضيّقوا النتائج حسب شركة الطيران والتوقفات ونطاق السعر وأوقات الرحلات.",
                    "fltResDynOutboundTitle": "رحلات الذهاب", "fltResDynOutboundDesc": "تصفحوا رحلات الذهاب المتاحة. تُظهر كل بطاقة شركة الطيران والمسار والأوقات والسعر للراكب.",
                    "fltResDynOutboundActionTitle": "اختاروا رحلة الذهاب", "fltResDynOutboundActionDesc": "انقروا على «اختيار رحلة» في البطاقة المفضلة لديكم لتثبيتها.",
                    "fltResDynReturnTitle": "رحلات الإياب", "fltResDynReturnDesc": "الآن اختاروا رحلة الإياب. تصفحوا جميع الخيارات المتاحة للعودة.",
                    "fltResDynReturnActionTitle": "اختاروا رحلة الإياب", "fltResDynReturnActionDesc": "انقروا على «اختيار رحلة» لتثبيت رحلة العودة.",
                    "fltResDynFinalTitle": "الرحلات المختارة", "fltResDynFinalDesc": "تم اختيار كلتا الرحلتين. راجعوا السعر المدمج قبل المتابعة.",
                    "fltResDynFinalActionTitle": "الانتقال للطلب", "fltResDynFinalActionDesc": "انقروا على «الانتقال للطلب» لمراجعة تفاصيل الحجز الكاملة.",
                    "fltViewAgentCommTitle": "عمولة الوكيل",
                    "fltViewAgentCommDesc": "راجعوا عمولة الوكيل المقترحة لهذه الرحلة قبل إضافتها إلى السلة.",
                    "fltViewCardTitle": "تفاصيل الرحلة", "fltViewCardDesc": "راجعوا معلومات الرحلة الكاملة — شركة الطيران والمسار والأوقات والتوقفات وخيارات الأمتعة — قبل الحجز.",
                    "fltViewPriceTitle": "ملخص السعر", "fltViewPriceDesc": "يُعرض السعر الإجمالي للراكب وكإجمالي كامل. يمكن للوكلاء تحديد عمولتهم قبل الإضافة للسلة.",
                    "fltViewTcTitle": "الشروط والأحكام", "fltViewTcDesc": "راجعوا قواعد التعرفة وسياسة الإلغاء — بما فيها القيود المهمة — قبل الإضافة للسلة.",
                    "fltViewActionTitle": "إضافة إلى السلة", "fltViewActionDesc": "انقروا على «إضافة إلى السلة» لحجز هذه الرحلة. ستُفتح السلة للمراجعة قبل الدفع.",
                    "fltCartProductsTitle": "سلتكم", "fltCartProductsDesc": "يمكن لسلة التسوق الخاصة بكم استيعاب منتجات متعددة من أي نوع — رحلات جوية وفنادق وباقات والمزيد. يمكنكم إضافة أي عدد من العناصر في طلب واحد. راجعوا ما تمت إضافته هنا قبل المتابعة.",
                    "fltCartItemsTitle": "عناصر السلة", "fltCartItemsDesc": "كل منتج في سلة التسوق مدرج هنا — تفاصيل الرحلة ونوع الغرفة والتواريخ وتوزيع الركاب. تأكدوا من صحة جميع العناصر قبل الحفظ أو المتابعة.",
                    "fltCartManageBaggageTitle": "إدارة الأمتعة", "fltCartManageBaggageDesc": "انقروا على هذا الزر لإدارة أمتعة كل راكب — أضيفوا حقائب إضافية أو اضبطوا خيارات الأمتعة لرحلتي الذهاب والإياب بشكل منفصل.",
                    "fltCartDiamondsTitle": "رصيد الماسات", "fltCartDiamondsDesc": "عدد الماسات يُظهر مكافأة الكاشباك التي ستحصلون عليها من هذا الحجز.",
                    "fltCartAgentTitle": "خيارات الوكيل", "fltCartAgentDesc": "بصفتكم وكلاء، لديكم تحكم كامل في عمولتكم على هذا الطلب. حددوا نسبة مئوية من الإجمالي أو مبلغاً ثابتاً لكل شخص — أنتم تقررون مقدار الربح الذي تكسبونه من كل حجز.",
                    "fltCartAgentProfitBtnTitle": "تغيير الربح", "fltCartAgentProfitBtnDesc": "انقروا على هذا الزر لفتح إعدادات الربح وتعديل كيفية احتساب العمولة.",
                    "fltCartAgentProfitInputsTitle": "إعدادات الربح", "fltCartAgentProfitInputsDesc": "أدخلوا نسبة من السعر الإجمالي أو مبلغاً ثابتاً للشخص. يطبّق النظام الوضع النشط.",
                    "fltCartAgentSendBtnTitle": "إرسال عرض", "fltCartAgentSendBtnDesc": "للحصول على رابط عرض مباشر: أولاً قوموا بتعيين عميل للطلب، ثم انقروا على حفظ العرض — هذا يُنشئ الرابط. بعد الحفظ، انقروا على هذا الزر لفتح لوحة إرسال العرض حيث يمكنكم نسخ الرابط المباشر وإرساله عبر واتساب أو مشاركته بالبريد الإلكتروني. يمنح الرابط المباشر عميلكم عرضاً في الوقت الفعلي للطلب مع أسعار محدّثة دائماً.",
                    "fltCartAssignCustomerTitle": "عيّنوا عميلاً", "fltCartAssignCustomerDesc": "انقروا على زر «تعيين عميل» لفتح نموذج تفاصيل العميل وربطه بهذا الطلب.",
                    "fltCartAssignModalTitle": "املؤوا تفاصيل العميل", "fltCartAssignModalDesc": "املؤوا الحقول المطلوبة — الاسم والهاتف والبريد الإلكتروني — وانقروا على حفظ العميل لربطه بهذا الطلب. تُغلق النافذة تلقائيًا بعد الحفظ.",
                    "fltCartCustomerTitle": "العميل المرتبط", "fltCartCustomerDesc": "العميل المعين يظهر هنا. مع وجود عميل مرتبط، يمكنكم حفظ الطلب ومشاركة رابط العرض المباشر — أو المتابعة إلى الدفع نيابةً عنه.",
                    "fltCartCreateOrderTitle": "حفظ ومشاركة العرض", "fltCartCreateOrderDesc": "انقروا على حفظ العرض عندما تكونوا مستعدين — هذا الخيار متاح فقط بعد تعيين عميل. يؤدي الحفظ إلى إنشاء رابط عرض مباشر: عندما يفتحه عميلكم تتحدث الأسعار تلقائياً وتنعكس الإتاحة في الوقت الفعلي. يمكنكم أيضاً إرسال عرض بدون رابط مباشر إذا كنتم تفضلون ذلك.",
                    "fltCartComparePriceTitle": "مقارنة الأسعار", "fltCartComparePriceDesc": "انقروا لمقارنة سعر هذه الرحلة لدى موردين آخرين وإيجاد الخيار الأفضل.",
                    "fltCartTotalTitle": "السعر الإجمالي", "fltCartTotalDesc": "السعر الإجمالي معروض هنا — بما في ذلك جميع المنتجات وعمولتكم. عندما تكونوا راضين، احفظوا الطلب كعرض لمشاركته مع العميل، أو انقروا على متابعة للدفع للانتقال إلى صفحة الدفع.",
                    "fltCartActionTitle": "متابعة للدفع", "fltCartActionDesc": "انقروا على «متابعة للدفع» للانتقال إلى الدفع وملء بيانات الركاب.",
                    "fltCartSaveOfferActionTitle": "احفظوا العرض لإنهاء الخطوة", "fltCartSaveOfferActionDesc": "انقروا على زر حفظ العرض لإنشاء رابط عرض مباشر وإنهاء هذه الخطوة. يمكنكم مشاركة الرابط مع العميل في أي وقت — يتم تحديث الأسعار والتوفر في الوقت الفعلي.",
                    "fltCheckoutCartTitle": "ملخص الطلب", "fltCheckoutCartDesc": "اللوحة اليسرى تُظهر ملخص الرحلة المختارة والمبلغ الإجمالي للدفع.",
                    "fltCheckoutCustomerInfoTitle": "معلومات العميل", "fltCheckoutCustomerInfoDesc": "أدخلوا التفاصيل الشخصية للحاجز في هذا القسم.",
                    "fltCheckoutFirstNameTitle": "الاسم الأول", "fltCheckoutFirstNameDesc": "أدخلوا الاسم الأول للحاجز كما يظهر في بطاقة الهوية أو جواز السفر.",
                    "fltCheckoutLastNameTitle": "اسم العائلة", "fltCheckoutLastNameDesc": "أدخلوا اسم عائلة الحاجز كما يظهر في بطاقة الهوية أو جواز السفر.",
                    "fltCheckoutPhoneTitle": "رقم الهاتف", "fltCheckoutPhoneDesc": "مطلوب رقم هاتف صالح لإرسال تفاصيل التأكيد للحاجز.",
                    "fltCheckoutEmailTitle": "البريد الإلكتروني", "fltCheckoutEmailDesc": "أدخلوا عنوان البريد الإلكتروني للحاجز لاستلام تأكيد الحجز والتذاكر الإلكترونية.",
                    "fltCheckoutGuestInfoTitle": "بيانات الركاب", "fltCheckoutGuestInfoDesc": "أدخلوا الاسم الكامل ورقم جواز السفر وتاريخ الميلاد لكل راكب بالضبط كما في جوازه.",
                    "fltCheckoutTCTitle": "الشروط والموافقة", "fltCheckoutTCDesc": "اقرؤوا ووافقوا على شروط الحجز قبل إرسال الطلب.",
                    "fltCheckoutFormTitle": "بيانات الركاب", "fltCheckoutFormDesc": "أدخلوا الاسم الكامل ورقم جواز السفر وتاريخ الميلاد لكل راكب بالضبط كما يظهر في جوازه.",
                    "fltCheckoutActionTitle": "تأكيد الطلب", "fltCheckoutActionDesc": "انقروا على «إرسال والمتابعة للدفع» لتأكيد بيانات الركاب والانتقال لخطوة الدفع.",
                    "abBannerTitle": "لوحة تحكم الوكيل",
                    "abBannerDesc": "هذا الشريط في أعلى B2C هو لوحة التحكم الحصرية للوكيل. يمنحك وصولاً سريعاً لإدارة العملاء وإعدادات التسعير ورصيد الماس وحسابك.",
                    "abExchangeTitle": "أسعار الصرف الحية",
                    "abExchangeDesc": "تُعرض أسعار الصرف الفورية هنا للرجوع إليها بسرعة عند التعامل مع الحجوزات متعددة العملات.",
                    "abOnboardingBtnTitle": "دليل الإعداد",
                    "abOnboardingBtnDesc": "انقر على أيقونة علامة الاستفهام في أي وقت لإعادة فتح دليل الإعداد والعودة إلى أي خطوة تحتاجها.",
                    "abSwitchersTitle": "مفاتيح وضع العمل",
                    "abSwitchersDesc": "مفتاحان: وضع الوكيل/العميل — عند تفعيل وضع الوكيل تظهر خيارات العمولة والأسعار المخصصة للوكلاء. سعر الإجمالي/الصافي — التبديل بين السعر الكامل وصافي التكلفة.",
                    "abCustomerSearchTitle": "البحث عن عميل",
                    "abCustomerSearchDesc": "ابحث عن عميل موجود بالاسم أو التفاصيل. اختيار العميل يربطه بالحجز الحالي ليظهر الطلب في حسابه ويُدار من لوحة التحكم الخلفية.",
                    "abUpgradePlanTitle": "ترقية الخطة",
                    "abUpgradePlanDesc": "يظهر هذا الزر عندما تكون الوكالة على خطة Light أو Regular. انقر عليه لفتح نافذة ترقية الخطة وفتح الميزات المتقدمة.",
                    "abDiamondsTitle": "رصيد الماس",
                    "abDiamondsDesc": "يُعرض هنا رصيدك من الكاش باك بعملة الماس. يشمل المجموع الأرباح المؤكدة بالإضافة إلى المكافآت المعلّقة المستقبلية. مرّر فوق الأيقونة للتفاصيل.",
                    "abUserMenuTitle": "حسابك",
                    "abUserMenuDesc": "انقر على اسمك لفتح قائمة الحساب — عرض ملفك الشخصي وحالة خطة الوكالة وتسجيل الخروج. انقر إنهاء لإتمام هذه الخطوة.",
                    "pkgResSearchActionTitle": "البحث عن باقة",
                    "pkgResSearchActionDesc": "أدخل تفاصيل رحلتك أعلاه وانقر بحث لعرض الباقات المتاحة.",
                    "pkgResOverviewTitle": "نتائج البحث",
                    "pkgResOverviewDesc": "هنا يمكنك رؤية جميع الباقات المتاحة المطابقة لبحثك. تعرض كل بطاقة الفندق والتواريخ والسعر والرحلات المضمّنة.",
                    "pkgResSideFiltersTitle": "تصفية النتائج",
                    "pkgResSideFiltersDesc": "استخدم الفلاتر الجانبية لتضييق النتائج حسب السعر والوجهة وتصنيف الفندق والمزيد.",
                    "pkgResCardTitle": "بطاقة الباقة",
                    "pkgResCardDesc": "تعرض كل بطاقة اسم الفندق وتواريخ السفر والرحلات والإضافات المضمّنة والسعر للفرد. انقر «للطلب» لفتح التفاصيل الكاملة.",
                    "pkgResActionTitle": "فتح تفاصيل الباقة",
                    "pkgResActionDesc": "انقر «للطلب» على أي بطاقة باقة لفتح التفاصيل الكاملة في تبويب جديد لاختيار الغرفة وإتمام الحجز.",
                    "pkgPageHotelTitle": "معلومات الفندق",
                    "pkgPageHotelDesc": "يعرض هذا القسم كل شيء عن الفندق في هذه الباقة — الصور والاسم والتصنيف بالنجوم وتواريخ الحجز.",
                    "pkgPageGalleryTitle": "صور الفندق",
                    "pkgPageGalleryDesc": "تصفح معرض الفندق — انقر على أي صورة لفتح العارض بالحجم الكامل واستعراض جميع الصور.",
                    "pkgPageDetailsTitle": "اسم الفندق وتقييمه",
                    "pkgPageDetailsDesc": "هنا يمكنك رؤية اسم الفندق والوجهة وتصنيف النجوم وتواريخ السفر والمدة الإجمالية للإقامة.",
                    "pkgPageIncludesTitle": "ما يشمله العرض",
                    "pkgPageIncludesDesc": "تسرد هذه المنطقة كل ما هو مدرج في سعر الباقة — الرحلات الجوية والتنقلات والأنشطة وتذاكر الفعاليات.",
                    "pkgPageFlightsTitle": "تفاصيل الرحلة",
                    "pkgPageFlightsDesc": "يعرض هذا القسم رحلات الذهاب والإياب المضمّنة في الباقة — شركة الطيران والأوقات والمسار.",
                    "pkgPageRoomsTitle": "اختيار الغرفة",
                    "pkgPageRoomsDesc": "فيما يلي جميع أنواع الغرف المتاحة لهذه الباقة. قارن الخيارات حسب السعر ونوع الإقامة وميزات الغرفة.",
                    "pkgPageRoomFiltersTitle": "فلاتر الغرف",
                    "pkgPageRoomFiltersDesc": "استخدم هذه الفلاتر لتضييق الخيارات حسب عدد الضيوف ونوع الإقامة (إفطار، نصف إقامة، كل شيء مشمول) أو اسم الغرفة.",
                    "pkgPageRoomCardTitle": "بطاقة الغرفة",
                    "pkgPageRoomCardDesc": "تعرض كل بطاقة غرفة صورة واسم الغرفة والمرافق المتاحة. مرر للأسفل داخل البطاقة لرؤية جميع صفوف الأسعار.",
                    "pkgPageRoomPriceTitle": "سعر الغرفة ونوع الإقامة",
                    "pkgPageRoomPriceDesc": "يعرض كل صف خطة الإقامة وسياسة الإلغاء وما هو مشمول والسعر الإجمالي. اختر الخيار الأنسب لعميلك.",
                    "pkgPageAddToCartTitle": "إضافة الغرفة إلى السلة",
                    "pkgPageAddToCartDesc": "انقر «إضافة للطلب» على الغرفة المختارة لإضافة هذه الباقة إلى سلتك والمتابعة إلى الدفع.",
                    "moOrderIdTitle": "رقم الطلب",
                    "moOrderIdDesc": "رقم طلبك معروض هنا. استخدمه للرجوع السريع إلى هذا الحجز عند التواصل مع الدعم أو تتبع الحجز.",
                    "moCartOverviewTitle": "ملخص الحجز",
                    "moCartOverviewDesc": "يعرض اللوح الأيسر ملخصاً كاملاً لحجزك — جميع المنتجات المحجوزة وتفاصيل الأسعار والإجراءات المتاحة.",
                    "moCartProductsTitle": "المنتجات المحجوزة",
                    "moCartProductsDesc": "كل عنصر في طلبك مدرج هنا — تفاصيل الرحلة ونوع الغرفة والتواريخ وعدد المسافرين. راجع جميع المنتجات قبل إجراء أي تغييرات.",
                    "moCartAgentTitle": "خيارات الوكيل",
                    "moCartAgentDesc": "بصفتك وكيلاً، يمكنك تعديل عمولتك على هذا الطلب — حدد نسبة مئوية أو مبلغاً ثابتاً لكل شخص. تؤثر التغييرات على السعر الإجمالي المعروض للعميل.",
                    "moCartTotalTitle": "إجمالي الطلب",
                    "moCartTotalDesc": "المبلغ الإجمالي الواجب دفعه معروض في أسفل العربة. راجعه بعناية — فهو يعكس جميع المنتجات بالإضافة إلى أي عمولة للوكيل تم تطبيقها.",
                    "moTitleAreaTitle": "إجراءات الصفحة",
                    "moTitleAreaDesc": "يعرض الجزء العلوي من النموذج عنوان الصفحة. يتيح لك زر «الانتقال إلى الدفع» المتابعة إلى خطوة الدفع بعد مراجعة تفاصيل الطلب وتحديثها.",
                    "moPaymentBtnTitle": "المتابعة إلى الدفع",
                    "moPaymentBtnDesc": "انقر على هذا الزر عندما تكون تفاصيل الطلب مكتملة وصحيحة. سيتم نقلك إلى قسم الدفع حيث يمكنك اختيار طريقة دفع وإكمال الحجز.",
                    "moFormTitle": "نموذج تفاصيل الطلب",
                    "moFormDesc": "يتيح لك هذا النموذج مراجعة وتحديث جميع تفاصيل الطلب — معلومات العميل وأسماء الضيوف وتفاصيل جواز السفر والطلبات الخاصة. أكمل جميع الحقول المطلوبة قبل المتابعة إلى الدفع."
                },
                "guideExplorer": {
                    "title": "مستكشف الدليل",
                    "subtitle": "استكشف الميزات بوتيرتك الخاصة",
                    "startBtn": "ابدأ",
                    "doneLabel": "تم",
                    "noSiteTooltip": "يتطلب موقعاً مُعدًّا",
                    "timesCompleted": "مرات مكتملة",
                    "filtersTitle": "الفلاتر"
                }
            },
            "changeApproval": {
                "greeting": "مرحباً",
                "subtitle": "تم تحديث رحلتك",
                "changeTableTitle": "تفاصيل التغيير",
                "colField": "الحقل",
                "colBefore": "قبل",
                "colAfter": "بعد",
                "confirmPrompt": "يرجى تأكيد علمك بهذا التغيير في حجزك.",
                "confirmBtn": "تأكيد التغيير",
                "declineBtn": "أرفض",
                "expiresLabel": "صالح حتى",
                "expiresIn": "تنتهي صلاحية الرابط خلال",
                "confirmedTitle": "تم تأكيد التغيير",
                "confirmedMsg": "لقد أكدت هذا التغيير في",
                "declinedTitle": "تم رفض التغيير",
                "declinedMsg": "لقد رفضت التغيير. سيتواصل معك فريقنا.",
                "expiredTitle": "انتهت صلاحية الرابط",
                "expiredMsg": "انتهت صلاحية هذا الرابط. يرجى التواصل مع الدعم.",
                "failedTitle": "الرابط غير متاح",
                "failedMsg": "هذا الرابط غير متاح. يرجى التواصل مع الدعم.",
                "errorBanner": "حدث خطأ. يرجى المحاولة مرة أخرى.",
                "loading": "جاري التحميل...",
                "days": "أيام",
                "hours": "ساعات",
                "minutes": "دقائق"
            }
        }
    }
};

export default translationsAr;